import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from './../../shared/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { UserService } from './../../@core/data/users.service';
import { ConfirmationService } from 'primeng/api';



@Component({
  selector: 'educational',
  templateUrl: './educationalformsemsgpibscitnewformat.component.html',
  providers: [ ConfirmationService]
})
export class educationalformsemsgpibscitnewformat implements OnInit {
  FeedbackForm: FormGroup;
  @Input() user_id: any;
  @Input() edu_id: any;
  @Input() amount_paid: string;
  @Input() admin_show: string;
  @Input() showSpecialization: string;
  @Input() course_name_auto: string;
  @Input() college_year_auto: string;
  @Input() enrollment_year_auto: number;
  @Input() specialisationlevel_auto: string;
  @Input() leaving_year_auto: number;
  @Input() seat_number: any;
  @Input() mu_seat_number: any;
  @Input() sgpi_gpa : any;

  validations_flag = false;
  feedback_message;
  showExperience = false;
  totalMarks: number;
  totalMarksOut: number;
  totalMarksObtained : number;
  totalMarksObtainedmyFunc : number;
  totalMaximumMarks : number;
  creditTotal: number;
  totalCnG: number;
  totalcgpa: any;

  edu_form: FormGroup;
  years_array;
  courseValidation = true;
  collegeYearValidation = true;
  semesterValidation = true;
  monthValidation = true;
  yearValidation = true;
  attemptValidation = true;
  instructionValidation = true;
  endmonthValidation = true;
  endYearValidation = true;

  edu_data;
  course_data;
  user: any;
  totalCourseCredits: any;
 
  enrollYear = [];
  enrollment_year:any;

  predictive_data;
  specialisation_data;
  specialisation_name: any;
  show_predictive: boolean =false;



  subjectPreName : any;
  subjectPreName2 : any;
  subjectPreName3 : any;
  subjectPreName4 : any;
  subjectPreName5 : any;
  subjectPreName6 : any;
  subjectPreName7 : any;
  subjectPreName8 : any;
  subjectPreName9 : any;
  subjectPreName10 : any;

  crerditsPre1 : any
  crerditsPre2 : any
  crerditsPre3 : any
  crerditsPre4 : any
  crerditsPre5 : any
  crerditsPre6 : any
  crerditsPre7 : any
  crerditsPre8 : any
  crerditsPre9 : any
  crerditsPre10 : any

  public filterInput = new FormControl();
  public filterInput2 = new FormControl();
  public filterInput3 = new FormControl();
  public filterInput4 = new FormControl();
  public filterInput5 = new FormControl();
  public filterInput6 = new FormControl();
  public filterInput7 = new FormControl();
  public filterInput8 = new FormControl();
  public filterInput9 = new FormControl();
  public filterInput10 = new FormControl();
  C_into_G: number;
  C_into_G2: number;
  C_into_G3: number;
  C_into_G4: number;
  C_into_G5: number;
  C_into_G6: number;
  C_into_G7: number;
  C_into_G8: number;
  C_into_G9: number;
  C_into_G10: number;
  th_ia_1 : number;
  th_ia_2 : number;
  th_ia_3 : number;
  th_ia_4 : number;
  th_ia_5 : number;
  th_ia_6 : number;
  th_ia_7 : number;
  th_ia_8 : number;
  th_ia_9 : number;
  th_ia_10 : number;
  // ba sgpi
  internal_marks: number;
  subjectName: any;
  withoutCodeSub: any;
  subjectName2: any;
  withoutCodeSub2: any;
  withoutCodeSub3: any;
  subjectName3: any;
  subjectName4: any;
  withoutCodeSub4: any;
  subjectName5: any;
  withoutCodeSub5: any;
  subjectName6: any;
  withoutCodeSub6: any;
  subjectName7: any;
  withoutCodeSub7: any;
  subjectName8: any;
  withoutCodeSub8: any;
  subjectName9: any;
  withoutCodeSub9: any;
  subjectName10: any;
  withoutCodeSub10: any;
  course_code: any;
  course_code8: any;
  course_code2: any;
  course_code3: any;
  course_code4: any;
  course_code5: any;
  course_code6: any;
  course_code7: any;
  course_code9: any;
  course_code10: any;
  public filterText: any;
  public filterText2: any;
  filterText3: any
  public filterText4: any;
  public filterText5: any;
  public filterText6: any;
  public filterText7: any;
  public filterText8: any;
  public filterText9: any;
  public filterText10: any;
  autocheck = true;
  specialInstructionArray = ['@ As per University of Mumbai Ordinance 0.5042A/0.5043A/0.5044A',
                              '& Scaled Down, Cir. No. UG/61 of 2013-2014',
                            '+ Carried Forward Marks as per Ordinance of University of Mumbai',
                            '* As per University of Mumbai Ordinance 0.5045a',
                            '$ - Carried forward grade as per ordinance of the University of Mumbai',
                            '# As per University of Mumbai, Ordinance 0.229'
                            ]
  specialInstruction: any;
  specI: any;
  remarks : any;
  GradespecialInstruction: any;
  DradespecI: any;
  newcourse_code = [];

  course_name: any;
  edu_level: any;
  college_year: any;
  semester_auto: any;
  showcodeDropdown: boolean = true;
  showcodeDropdown2: boolean = true;
  showcodeDropdown3: boolean = true;
  showcodeDropdown4: boolean = true;
  showcodeDropdown5: boolean = true;
  showcodeDropdown6: boolean = true;
  showcodeDropdown7: boolean = true;
  showcodeDropdown8: boolean = true;
  showcodeDropdown9: boolean = true;
  showcodeDropdown10: boolean = true;

  preEditFirst: boolean = false;
  preEditSecond: boolean = false;
  preEditThird: boolean = false;
  preEditFourth: boolean = false;
  preEditFifth: boolean = false;
  preEditSixth: boolean = false;
  preEditSeventh: boolean = false;
  preEditEight: boolean = false;
  preEditNinth: boolean = false;
  preEditTenth: boolean = false;

  editShow1 : boolean = false;
  editShow2 : boolean = false;
  editShow3 : boolean = false;
  editShow4 : boolean = false;
  editShow5 : boolean = false;
  editShow6 : boolean = false;
  editShow7 : boolean = false
  editShow8 : boolean = false;
  editShow9 : boolean = false;
  editShow10 : boolean = false;

  isDisabled = false;
  startmonth;
  startYear;
  totalValue: number;
  totalMarksmyFunc : number;
  totalMarksOutmyFunc : number
  totalValue2: number;
  totalValue3: number;
  totalValue4: number;
  totalValue5: number;
  totalValue6: number;
  totalValue7: number;
  totalValue8: number;
  totalValue9: number;
  totalValue10: number;

  instruction1: boolean =false;                          
  instruction2: boolean =false;                          
  instruction3: boolean =false;                          
  instruction4: boolean =false;                          
  instruction5: boolean =false;                          
  instruction6: boolean =false;   
  instruction7: boolean =false;  

  special_instruction1: any = null;                          
  special_instruction2: any = null;                          
  special_instruction3: any = null;                          
  special_instruction4: any = null;                          
  special_instruction5: any = null;                          
  special_instruction6: any = null;
  special_instruction7: any = null;
 
  subjectArray = [];
  subjectArray2 = [];
  subjectArray3 = [];
  subjectArray4 = [];
  subjectArray5 = [];
  subjectArray6 = [];
  subjectArray7 = [];
  subjectArray8 = [];
  subjectArray9 = [];
  subjectArray10 = [];
  courseCodePreName: any;
  courseCodePreName2: any;
  courseCodePreName3: any;
  courseCodePreName4: any;
  courseCodePreName5: any;
  courseCodePreName6: any;
  courseCodePreName7: any;
  courseCodePreName8: any;
  courseCodePreName9: any;
  courseCodePreName10: any;
  still_studying: any;
  stillStudy: any;


  constructor(protected api: ApiService,
    private router: Router,
    private userService: UserService,
    public toasterService: NbToastrService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    protected ref: NbDialogRef<educationalformsemsgpibscitnewformat>) { }

  async ngOnInit() {
    if (this.admin_show == "true") {
      this.isDisabled = false;
    } else {
      //this.edu_form.controls['lecturehourFirstCtrl'].disable();

      this.isDisabled = !this.isDisabled;
    }
    // this.userService.onUserChange()
    // .subscribe((user: any) => this.user = user);
    // if(this.user.role == 'admin'){
    //   this.admin_show = false;
    // }

    this.edu_form = this.formBuilder.group({
      courseNameCtrl: ['', Validators.required],
      collegeYearCtrl: ['', Validators.required],
      semesterCtrl: ['', Validators.required],
      monthCtrl: ['', Validators.required],
      yearCtrl: ['', Validators.required],
      endyearCtrl: [''],
      endmonthCtrl: [''],
      stlStdmonthCtrl :  [''],
      startyearCtrl: [''],
      seatNumberCtrl: [ '' , Validators.required],
      overAllGradeCtrl: ['', Validators.required],
      overAllgpasgpiCtrl: ['', [Validators.required,Validators.pattern( "^[0-9]+(.[0-9]{0,2})?$")]],
      subjectFirstCtrl: [''],
      // markFirstCtrl: ['', Validators.required],
      // markFirstOutCtrl: ['', Validators.required],
      gradeFirstCtrl: [''],
      gradepointsFirstCtrl: ['', Validators.required],
      gradecreditsFirstCtrl: ['', Validators.required],
      subjectSecondCtrl: [''],
      markSecondCtrl: [''],
      markSecondOutCtrl: [''],
      gradeSecondCtrl: [''],
      gradepointsSecondCtrl: [''],
      gradecreditsSecondCtrl: [''],
      subjectThirdCtrl: [''],
      markThirdCtrl: [''],
      markThirdOutCtrl: [''],
      gradeThirdCtrl: [''],
      gradepointsThirdCtrl: [''],
      gradecreditsThirdCtrl: [''],
      subjectFourthCtrl: [''],
      markFourthCtrl: [''],
      markFourthOutCtrl: [''],
      gradeFourthCtrl: [''],
      gradepointsFourthCtrl: [''],
      gradecreditsFourthCtrl: [''],
      subjectFifthCtrl: [''],
      markFifthCtrl: [''],
      markFifthOutCtrl: [''],
      gradeFifthCtrl: [''],
      gradepointsFifthCtrl: [''],
      gradecreditsFifthCtrl: [''],
      subjectSixthCtrl: [''],
      markSixthCtrl: [''],
      markSixthOutCtrl: [''],
      gradeSixthCtrl: [''],
      gradepointsSixthCtrl: [''],
      gradecreditsSixthCtrl: [''],
      subjectSeventhCtrl: [''],
      markSeventhCtrl: [''],
      markSeventhOutCtrl: [''],
      gradeSeventhCtrl: [''],
      gradepointsSeventhCtrl: [''],
      gradecreditsSeventhCtrl: [''],
      subjectEighthCtrl: [''],
      markEighthCtrl: [''],
      markEighthOutCtrl: [''],
      gradeEighthCtrl: [''],
      gradepointsEighthCtrl: [''],
      gradecreditsEighthCtrl: [''],
      instructionCtrl: ['', Validators.required],
      subjectNinthCtrl: [''],
      markNinthCtrl: [''],
      markNinthOutCtrl: [''],
      gradeNinthCtrl: [''],
      gradepointsNinthCtrl: [''],
      gradecreditsNinthCtrl: [''],
      subjectTenthCtrl: [''],
      markTenthCtrl: [''],
      markTenthOutCtrl: [''],
      gradeTenthCtrl: [''],
      gradepointsTenthCtrl: [''],
      gradecreditsTenthCtrl: [''],
      specialInstrctionCtrl: [''],
      finalgradespecialInstrctionCtrl: [''],
      totalweeksCtrl: [''],
      totalCourseCreditsCtrl : [''],
      creditsEarnedCFirstCtrl: ['', Validators.required],
      creditsEarnedCSecondCtrl: [''],
      creditsEarnedCThirdCtrl: [''],
      creditsEarnedCFourthCtrl: [''],
      creditsEarnedCFifthCtrl: [''],
      creditsEarnedCSixthCtrl: [''],
      creditsEarnedCSevenCtrl: [''],
      creditsEarnedCEightCtrl: [''],
      creditsEarnedCNinthCtrl: [''],
      creditsEarnedCtehthCtrl: [''],
      internalMarksCtrl: [''],
      internalMarksSecondCtrl: [''],
      internalMarksThirdCtrl: [''],
      internalMarksFourthCtrl: [''],
      internalMarksFifthCtrl: [''],
      internalMarksSixthCtrl: [''],
      internalMarksSeventhCtrl: [''],
      internalMarksEightCtrl: [''],
      internalMarksNineCtrl: [''],
      internalMarksTenCtrl: [''],
      semEndFirstCtrl: [''],
      semEndSecondCtrl: [''],
      semEndThirdCtrl: [''],
      semEndFourthCtrl: [''],
      semEndFifthCtrl: [''],
      semEndSixthCtrl: [''],
      semEndSeventhCtrl: [''],
      semEndEightCtrl: [''],
      semEndNinthCtrl: [''],
      semEndTenthCtrl: [''],
     
      totalCCtrl: ['', Validators.required],
      totalCnGCtrl: ['', Validators.required],
      OverallCGPACtrl: [''],
      finalGradeCtrl: [''],
      SpecialisationCtrl :[''],
      overmarksoutCtrl :[''],

      iaFirstCtrl : [''],
      iaSecondCtrl : [''],
      iaThirdCtrl : [''],
      iaFourthCtrl : [''],
      iaFifthCtrl : [''],
      iaSixthCtrl : [''],
      iaSeventhCtrl : [''],
      iaEightCtrl : [''],
      iaNinthCtrl : [''],
      iaTenthCtrl : [''],

      // ba sgpi
      minInternalMarksFirstCtrl : [''],

      thFirstCtrl : [''],
      thSecondCtrl : [''],
      thThirdCtrl : [''],
      thFourthCtrl : [''],
      thFifthCtrl : [''],
      thSixthCtrl : [''],
      thSeventhCtrl : [''],
      thEightCtrl : [''],
      thNinthCtrl : [''],
      thTenthCtrl : [''],

      firstTotalMarksCtrl : [''],
      secondTotalMarksCtrl : [''],
      thirdTotalMarksCtrl : [''],
      fourthTotalMarksCtrl : [''],
      fifthTotalMarksCtrl : [''],
      sixthTotalMarksCtrl : [''],
      seventhTotalMarksCtrl : [''],
      eightTotalMarksCtrl : [''],
      nineTotalMarksCtrl : [''],
      tenTotalMarksCtrl : [''],
      overAllTotalCtrl : [''],

      courseCreditsFirstCtrl : [''],
      courseCreditsSecondCtrl : [''],
      courseCreditsThirdCtrl : [''],
      courseCreditsFourthCtrl : [''],
      courseCreditsFifthCtrl : [''],
      courseCreditsSixthCtrl : [''],
      courseCreditsSeventhCtrl : [''],
      courseCreditsEightCtrl : [''],
      courseCreditsNinthCtrl : [''],
      courseCreditsTenthCtrl : [''],

      maxMarksFirstCtrl: [''],
      maxMarksSecondCtrl : [''],
      maxMarksThirdCtrl : [''],
      maxMarksFourthCtrl : [''],
      maxMarksFifthCtrl : [''],
      maxMarksSixthCtrl : [''],
      maxMarksSeventhCtrl : [''],
      maxMarksEightCtrl : [''],
      maxMarksNinthCtrl : [''],
      maxMarksTenthCtrl : [''],

      minMarksFirstCtrl: [''],
      minMarksSecondCtrl : [''],
      minMarksThirdCtrl : [''],
      minMarksFourthCtrl : [''],
      minMarksFifthCtrl : [''],
      minMarksSixthCtrl : [''],
      minMarksSeventhCtrl : [''],
      minMarksEightCtrl : [''],
      minMarksNinthCtrl : [''],
      minMarksTenthCtrl : [''],

      markObtFirstCtrl : [''],
      markObtSecondCtrl : [''],
      markObtThirdCtrl : [''],
      markObtFourthCtrl : [''],
      markObtFifthCtrl : [''],
      markObtSixthCtrl : [''],
      markObtSeventhCtrl : [''],
      markObtEightCtrl : [''],
      markObtNinthCtrl : [''],
      markObtTenthCtrl : [''],

      remarksCtrl : [''],
      resultCtrl : [''],
      totalMaxMarksCtrl : [''],
      totalMarksObtCtrl : [''],

      subjectEditFirstCtrl : [ '' ],
      subjectEditSecondCtrl : [ '' ],
      subjectEditThirdCtrl : [ '' ],
      subjectEditFourthCtrl : [ '' ],
      subjectEditFifthCtrl : [ '' ],
      subjectEditSixthCtrl : [ '' ],
      subjectEditSeventhCtrl : [ '' ],
      subjectEditEightCtrl : [ '' ],
      subjectEditNinthCtrl : [ '' ],
      subjectEditTenthCtrl : [ '' ],


      courseEdit1Ctrl : [''],
      courseEdit2Ctrl : [''],
      courseEdit3Ctrl : [''],
      courseEdit4Ctrl : [''],
      courseEdit5Ctrl : [''],
      courseEdit6Ctrl : [''],
      courseEdit7Ctrl : [''],
      courseEdit8Ctrl : [''],
      courseEdit9Ctrl : [''],
      courseEdit10Ctrl : [''],

      // coursecode controller
      courseCodeFirstCtrl : [''],
      courseCodeSecondCtrl : [''],
      courseCodeThirdCtrl : [''],
      courseCodeFourCtrl : [''],
      courseCodeFiveCtrl : [''],
      courseCodeSixCtrl : [''],
      courseCodeSevenCtrl : [''],
      courseCodeEightCtrl : [''],
      courseCodeNineCtrl : [''],
      courseCodeTenCtrl : [''],


      creditsFirstCtrl : [''],
      creditsSecondCtrl : [''],
      creditsThirdCtrl : [''],
      creditsFourthCtrl : [''],
      creditsFifthCtrl : [''],
      creditsSixthCtrl : [''],
      creditsSeventhCtrl : [''],
      creditsEightCtrl : [''],
      creditsNinthCtrl : [''],
      creditsTenthCtrl : [''],
      footnotesCtrl : [''],
      sgpiInstCtrl : [''],
      sem1sgpidetailsctrl: [''],
      sem2sgpidetailsctrl: [''],
      sem3sgpidetailsctrl: [''],
      sem4sgpidetailsctrl: [''],
      sem5sgpidetailsctrl: [''],

    })

    if (this.college_year_auto == 'SemesterOne' || this.college_year_auto == 'SemesterTwo') {
      this.college_year = 'First';
      if (this.college_year_auto == 'SemesterOne') {
        this.semester_auto = 'I';
      } else {
        this.semester_auto = 'II';
      }
    } else if (this.college_year_auto == 'SemesterThree' || this.college_year_auto == 'SemesterFour') {
      this.college_year = 'Second';
      if (this.college_year_auto == 'SemesterThree') {
        this.semester_auto = 'III';
      } else {
        this.semester_auto = 'IV';
      }
    } else if (this.college_year_auto == 'SemesterFive' || this.college_year_auto == 'SemesterSix') {
      this.college_year = 'Third';
      if (this.college_year_auto == 'SemesterFive') {
        this.semester_auto = 'V';
      } else {
        this.semester_auto = 'VI';
      }
    }

    this.api.getStillStudying(this.user_id)
    .subscribe(
      (data: any) => {
        
        if (data['status'] == 200) {
          this.still_studying = data['data'];
          
          
          this.stillStudy = this.still_studying.stillStudying;
          
        } else {

        }
      });
    this.api.getCouses()
      .subscribe(
        (data: any) => {
          if (data['status'] == 200) {
            this.course_data = data['data'];
            if (this.course_name_auto != null) {
              this.course_data.forEach(element => {
                if (element.CourseName == this.course_name_auto || element.CourseShortForm == this.course_name_auto) {
                  this.course_name = element.CourseShortForm;
                  this.edu_level = element.type;
                }
              });
            }
           
          } else {

          }
          this.api.getCouseCode('sem',this.course_name,this.semester_auto, this.sgpi_gpa).subscribe((data: any) => {
            if (data["status"] == 200) {
              
              this.autocheck = false;
              this.filterText = "";
              this.course_code = data["data"];
              this.filterInput.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText = term;
              });
              
              // this.autocheck = false;
              this.filterText2 = "";
              this.course_code2 = data["data"];
              this.filterInput2.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText2 = term;
              });

              // this.autocheck = false;
              this.filterText3 = "";
              this.course_code3 = data["data"];
              this.filterInput3.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText3 = term;
              });
              
              // this.autocheck = false;
              this.filterText4 = "";
              this.course_code4 = data["data"];
              this.filterInput4.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText4 = term;
              });

              // this.autocheck = false;
              this.filterText5 = "";
              this.course_code5 = data["data"];
              this.filterInput5.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText5 = term;
              });

              // this.autocheck = false;
              this.filterText6 = "";
              this.course_code6 = data["data"];
              this.filterInput6.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText6 = term;
              });

              // this.autocheck = false;
              this.filterText7 = "";
              this.course_code7 = data["data"];
              this.filterInput7.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText7 = term;
              });

              // this.autocheck = false;
              this.filterText8 = "";
              this.course_code8 = data["data"];
              this.filterInput8.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText8 = term;
              });

              // this.autocheck = false;
              this.filterText9 = "";
              this.course_code9 = data["data"];
              this.filterInput9.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText9 = term;
              });

              // this.autocheck = false;
              this.filterText10 = "";
              this.course_code10 = data["data"];
              this.filterInput10.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText10 = term;
              });

              
      
              
            } else {
            }
          });
        });

        this.api.getAllSpecialisation()
        .subscribe(
          (data: any) => {
            if (data['status'] == 200) {
              this.specialisation_data = data['data'];
              if (this.specialisationlevel_auto != null) {
                this.specialisation_data.forEach(element => {
                  
                  if (element.specialisation_name == this.specialisationlevel_auto) {
                    this.specialisation_name = element.specialisation_name;
                  }
                });
              }
             
            } else {
    
            }
          });

    const now = new Date().getUTCFullYear();
    this.years_array = Array(now - (now - 50)).fill('').map((v, idx) => now - idx);
    for(let info of this.years_array){
      if(info >= this.enrollment_year_auto){
        this.enrollYear.push(info)
        
       }
    }this.getEduDetails()
  }
  getEduDetails(){
    
    
    if (this.user_id != null && this.edu_id != null) {
      this.api.getEducation(this.edu_id, this.user_id)
        .subscribe(
          (data: any) => {
            if (data['status'] == 200) {
              this.edu_data = data['data'];

              if(this.edu_data.special_instruction1){
                this.instruction1=true;
                this.special_instruction1 =this.edu_data.special_instruction1;
              }else{
                this.instruction1=false;
                this.special_instruction1 =null;
              }
              if(this.edu_data.special_instruction2){
                this.instruction2=true;
                this.special_instruction2 =this.edu_data.special_instruction2;
              }else{
                this.instruction2=false;
                this.special_instruction2 =null;
              }
              if(this.edu_data.special_instruction3){
                this.instruction3=true;
                this.special_instruction3 =this.edu_data.special_instruction3;
              }else{
                this.instruction3=false;
                this.special_instruction3 =null;
              } 
              if(this.edu_data.special_instruction4){
                this.instruction4=true;
                this.special_instruction4 =this.edu_data.special_instruction4;
              }else{
                this.instruction4=false;
                this.special_instruction4 =null;
              } 
              if(this.edu_data.special_instruction5){
                this.special_instruction5 =this.edu_data.special_instruction5;
                this.instruction5=true;
              }else{
                this.instruction5=false;
                this.special_instruction5 =null;
              } 
              if(this.edu_data.special_instruction6){
                this.instruction6=true;
                this.special_instruction6 =this.edu_data.special_instruction6;
              }else{
                this.instruction6=false;
                this.special_instruction6 =null;
              }
              if(this.edu_data.special_instruction7){
                this.instruction7=true;
                this.special_instruction7 =this.edu_data.special_instruction7;
              }else{
                this.instruction7=false;
                this.special_instruction7 =null;
              }

              this.course_name = this.edu_data.CourseName;
              this.college_year = this.edu_data.CollegeYear;
              this.semester_auto = this.edu_data.Semester;
              this.specialisation_name = this.edu_data.specialisation;
              this.enrollment_year = this.edu_data.Year;
              if (
                this.edu_data.course_code_first != null &&
                this.edu_data.course_code_first != "" &&
                this.edu_data.course_code_first != undefined
              ) {
                this.showcodeDropdown = false;
                setTimeout(() => {
                  
                  this.course_code.forEach((element) => {
                    
                    if (element["Course_code"] == this.edu_data.course_code_first) {
                      this.subjectArray.push(element);
                    }
                  });
                }, 3000);
                
              } else {
                
                this.showcodeDropdown = true;
              }
              if (this.edu_data.course_code_second != null) {
                this.showcodeDropdown2 = false;
                setTimeout(() => {
                  this.course_code2.forEach((element) => {
                    if (element["Course_code"] == this.edu_data.course_code_second) {
                      this.subjectArray2.push(element);
                    }
                  });
                }, 3000);
                
              } else {
                
                this.showcodeDropdown2 = true;
              }
              if (
                this.edu_data.course_code_third != null &&
                this.edu_data.course_code_third != "" &&
                this.edu_data.course_code_third != undefined
              ) {
                this.showcodeDropdown3 = false;
                
                setTimeout(() => {
                  this.course_code3.forEach((element) => {
                    if (
                      element["Course_code"] == this.edu_data.course_code_third
                    ) {
                      this.subjectArray3.push(element);
                    }
                  });
                }, 3000);
              } else {
                
                this.showcodeDropdown3 = true;
              }
              if (
                this.edu_data.course_code_fourth != null &&
                this.edu_data.course_code_fourth != "" &&
                this.edu_data.course_code_fourth != undefined
              ) {
                this.showcodeDropdown4 = false;
                
                setTimeout(() => {
                  this.course_code4.forEach((element) => {
                    if (
                      element["Course_code"] == this.edu_data.course_code_fourth
                    ) {
                      this.subjectArray4.push(element);
                    }
                  });
                }, 4000);
              } else {
                
                this.showcodeDropdown4 = true;
              }
              if (
                this.edu_data.course_code_fifth != null &&
                this.edu_data.course_code_fifth != "" &&
                this.edu_data.course_code_fifth != undefined
              ) {
                this.showcodeDropdown5 = false;
                
                setTimeout(() => {
                  this.course_code5.forEach((element) => {
                    if (
                      element["Course_code"] == this.edu_data.course_code_fifth
                    ) {
                      this.subjectArray5.push(element);
                    }
                  });
                }, 4000);
              } else {
                
                this.showcodeDropdown5 = true;
              }
              if (
                this.edu_data.course_code_sixth != null &&
                this.edu_data.course_code_sixth != "" &&
                this.edu_data.course_code_sixth != undefined
              ) {
                this.showcodeDropdown6 = false;
                
                setTimeout(() => {
                  this.course_code6.forEach((element) => {
                    if (element["Course_code"] == this.edu_data.course_code_sixth) {
                      this.subjectArray6.push(element);
                    }
                  });
                }, 4000);
              } else {
                
                this.showcodeDropdown6 = true;
              }
              if (
                this.edu_data.course_code_seventh != null &&
                this.edu_data.course_code_seventh != "" &&
                this.edu_data.course_code_seventh != undefined
              ) {
                this.showcodeDropdown7 = false;
                
                setTimeout(() => {
                  this.course_code7.forEach((element) => {
                    if (
                      element["Course_code"] == this.edu_data.course_code_seventh
                    ) {
                      this.subjectArray7.push(element);
                    }
                  });
                }, 4000);
              } else {
                
                this.showcodeDropdown7 = true;
              }
              if (
                this.edu_data.course_code_eight != null &&
                this.edu_data.course_code_eight != "" &&
                this.edu_data.course_code_eight != undefined
              ) {
                this.showcodeDropdown8 = false;
                setTimeout(() => {
                  this.course_code8.forEach((element) => {
                    if (
                      element["Course_code"] == this.edu_data.course_code_eight
                    ) {
                      this.subjectArray8.push(element);
                    }
                  });
                }, 5000);
                
              } else {
                
                this.showcodeDropdown8 = true;
              }
              if (
                this.edu_data.course_code_ninth != null &&
                this.edu_data.course_code_ninth != "" &&
                this.edu_data.course_code_ninth != undefined
              ) {
                this.showcodeDropdown9 = false;
                setTimeout(() => {
                  this.course_code9.forEach((element) => {
                    if (
                      element["Course_code"] == this.edu_data.course_code_ninth
                    ) {
                      this.subjectArray9.push(element);
                    }
                  });
                }, 4000);
                
              } else {
                
                this.showcodeDropdown9 = true;
              }
              if (
                this.edu_data.course_code_tenth != null &&
                this.edu_data.course_code_tenth != "" &&
                this.edu_data.course_code_tenth != undefined
              ) {
                this.showcodeDropdown10 = false;
                setTimeout(() => {
                  this.course_code10.forEach((element) => {
                    if (
                      element["Course_code"] == this.edu_data.course_code_tenth
                    ) {
                      this.subjectArray10.push(element);
                    }
                  });
                }, 4000);
                
              } else {
                
                this.showcodeDropdown10 = true;
              }
              if(this.edu_data.Subject_First != null && this.edu_data.Subject_First != '' && this.edu_data.Subject_First != undefined){
                this.showcodeDropdown = false
                
              }else{
                
                this.showcodeDropdown = true
              }
              if(this.edu_data.Subject_Second != null){
                this.showcodeDropdown2 = false
                
              }else{
                
                this.showcodeDropdown2 = true
              }
              if(this.edu_data.Subject_Third != null && this.edu_data.Subject_Third != '' && this.edu_data.Subject_Third != undefined){
                this.showcodeDropdown3 = false
                
              }else{
                
                this.showcodeDropdown3 = true
              }
              if(this.edu_data.Subject_Fourth != null && this.edu_data.Subject_Fourth != '' && this.edu_data.Subject_Fourth != undefined){
                this.showcodeDropdown4 = false
                
              }else{
                
                this.showcodeDropdown4 = true
              }
              if(this.edu_data.Subject_Fifth != null && this.edu_data.Subject_Fifth != '' && this.edu_data.Subject_Fifth != undefined){
                this.showcodeDropdown5 = false
                
              }else{
                
                this.showcodeDropdown5 = true
              }
              if(this.edu_data.Subject_Six != null && this.edu_data.Subject_Six != '' && this.edu_data.Subject_Six != undefined){
                this.showcodeDropdown6 = false
                
              }else{
                
                this.showcodeDropdown6 = true
              }
              if(this.edu_data.Subject_Seventh != null && this.edu_data.Subject_Seventh != '' && this.edu_data.Subject_Seventh != undefined){
                this.showcodeDropdown7 = false
                
              }else{
                
                this.showcodeDropdown7 = true
              }
              if(this.edu_data.Subject_Eighth != null && this.edu_data.Subject_Eighth != '' && this.edu_data.Subject_Eighth != undefined){
                this.showcodeDropdown8 = false
                
              }else{
                
                this.showcodeDropdown8 = true
              }
  
              if(this.edu_data.Subject_Ninth != null && this.edu_data.Subject_Ninth != '' && this.edu_data.Subject_Ninth != undefined){
                this.showcodeDropdown9 = false
                
              }else{
                
                this.showcodeDropdown9 = true
              }
              if(this.edu_data.Subject_Tenth != null && this.edu_data.Subject_Tenth != '' && this.edu_data.Subject_Tenth != undefined){
                this.showcodeDropdown10 = false
                
              }else{
                
                this.showcodeDropdown10 = true
              }
             
            } else {
              
            }
          });
    } else {
      
    }
  }
  changeValue(value:any){
    
    if(value){
      this.api.getPredictiveCourse('sem',this.course_name_auto, this.semester_auto, value, this.college_year,this.specialisationlevel_auto).
      subscribe((data : any)=>{
        
        if(data['status'] == 200){
          this.predictive_data = data['data'];
          
            this.predictive_data.forEach(element => {
              
              this.subjectPreName = element.Subject_First;
              this.subjectPreName2 = element.Subject_Second;
              this.subjectPreName3 = element.Subject_Third
              this.subjectPreName4 = element.Subject_Fourth;
              this.subjectPreName5 = element.Subject_Fifth;
              this.subjectPreName6 = element.Subject_Six
              this.subjectPreName7 = element.Subject_Seventh;
              this.subjectPreName8 = element.Subject_Eighth;
              this.subjectPreName9 = element.Subject_Ninth;
              this.subjectPreName10 = element.Subject_Tenth;

              this.courseCodePreName = element.course_code_first;
              this.courseCodePreName2 = element.course_code_second;
              this.courseCodePreName3 = element.course_code_third;
              this.courseCodePreName4 = element.course_code_fourth;
              this.courseCodePreName5 = element.course_code_fifth;
              this.courseCodePreName6 = element.course_code_sixth;
              this.courseCodePreName7 = element.course_code_seventh;
              this.courseCodePreName8 = element.course_code_eight;
              this.courseCodePreName9 = element.course_code_ninth;
              this.courseCodePreName10 = element.course_code_tenth;

              this.crerditsPre1 = element.course_credits_first;
              this.crerditsPre2 = element.course_credits_second;
              this.crerditsPre3 = element.course_credits_third;
              this.crerditsPre4 = element.course_credits_fourth;
              this.crerditsPre5 = element.course_credits_fifth;
              this.crerditsPre6 = element.course_credits_sixth;
              this.crerditsPre7 = element.course_credits_seventh;
              this.crerditsPre8 = element.course_credits_eight;
              this.crerditsPre9 = element.course_credits_ninth;
              this.crerditsPre10 = element.course_credits_tenth;

              
                  if(value == element.Year){
                  this.show_predictive = true;
                   
              }
            });
          
        }
          else{
            this.show_predictive = false;
                    
                    this.api.getCouseCodeNew('sem',this.course_name_auto, this.semester_auto, this.specialisationlevel_auto,this.college_year, this.sgpi_gpa)
                    .subscribe(
                      (data: any) => {
                        if (data['status'] == 200) {
                          this.autocheck = false
                          this.filterText = "";
                          this.course_code = data['data'];
                          
                          this.filterInput
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                             
                              this.filterText =   term;
                
                            });
                            this.course_code2 = data['data']
                            this.filterInput2
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText2 =   term;
                
                            });
                
                            this.course_code3 = data['data']
                            this.filterInput3
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText3 =   term;
                
                            });
                            this.course_code4 = data['data']
                            this.filterInput4
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText4 =   term;
                
                            });
                            this.course_code5 = data['data']
                            this.filterInput5
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText5 =   term;
                
                            });
                            this.course_code6 = data['data']
                            this.filterInput6
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText6 =   term;
                
                            });
                            this.course_code7 = data['data']
                            this.filterInput7
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText7 =   term;
                
                            });
                            this.course_code8 = data['data']
                            this.filterInput8
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                             
                              this.filterText8 =   term;
                
                            });
                            this.course_code9 = data['data']
                            this.filterInput9
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText9 =   term;
                
                            });
                            this.course_code10 = data['data']
                            this.filterInput10
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText10 =   term;
                
                            });
                        }         
          })
      }
    });   
  } 
}


  // getCourse(value) {
  
  //   //this.filterText = "";
  //   this.subjectName = value

  //   var count = 0
  //   this.newcourse_code = [];
  //   this.course_code.forEach(element => {
  //     count++
  //     if (element['id'] == this.subjectName['id']) {
  
  //     } else {
  
  //       this.newcourse_code.push(element)

  
  //     }

  //     if (count == this.course_code.length) {
  //       this.course_code = this.newcourse_code
  //     }
  //   })
  //   // if(value.prac == 'yes'){
  
  //   //   this.prac_hour1 = value.Lec_per_Week
  //   //   this.lec_per_week1 = '-'
  //   // }else{
  //   //   this.lec_per_week1 = value.Lec_per_Week
  //   //   this.prac_hour1 = '-'
  
  //   // }
  //   //this.filterPlaceholder = "Search";
  //   // this.adminApi.getAllCourse(value).subscribe((data)=>{
  //   //   this.courses = data['data'];
  //   // })
  //   // this.filterInput
  //   //   .valueChanges
  //   //   .debounceTime(200)
  //   //   .subscribe(term => {
  //   //   this.filterText = term;
  //   // });
  // }

  // getSubject(event: any) {
  
  //   this.withoutCodeSub = event.target.value
  //   if (this.subjectName) {
  
  //   } else {
  
  //   }
  // }

  // getCourse2(value) {
  
  //   //this.filterText = "";
  //   this.subjectName2 = value

  //   var count = 0
  //   this.newcourse_code = [];
  //   this.course_code3.forEach(element => {
  //     count++
  //     if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id']) {
  
  //     } else {
  
  //       this.newcourse_code.push(element)

  
  //     }

  //     if (count == this.course_code3.length) {
  //       this.course_code3 = [];
  //       this.course_code3 = this.newcourse_code
  //     }
  //   })
  //   // if(value.prac == 'yes'){
  
  //   //   this.prac_hour2 = value.Lec_per_Week
  //   //   this.lec_per_week2 = '-'
  //   // }else{
  //   //   this.lec_per_week2 = value.Lec_per_Week
  //   //   this.prac_hour2 = '-'
  
  //   // }
  // }

  // getSubject2(event: any) {
  
  //   this.withoutCodeSub2 = event.target.value

  // }

  // getCourse3(value) {
  //   this.subjectName3 = value
  //   var count = 0
  //   var count = 0
  //   this.newcourse_code = [];
  //   this.course_code4.forEach(element => {
  //     count++
  //     if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id']) {
  
  //     } else {
  
  //       this.newcourse_code.push(element)

  
  //     }

  //     if (count == this.course_code4.length) {
  //       this.course_code4 = [];
  //       this.course_code4 = this.newcourse_code
  //     }
  //   })
  // }

  // getSubject3(event: any) {
  //   this.withoutCodeSub3 = event.target.value
  // }

  // getCourse4(value) {

  //   this.subjectName4 = value
  //   var count = 0
  //   this.newcourse_code = [];
  //   this.course_code5.forEach(element => {
  //     count++
  //     if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id']) {

  //     } else {

  //       this.newcourse_code.push(element)

  
  //     }

  //     if (count == this.course_code5.length) {
  //       this.course_code5 = [];
  //       this.course_code5 = this.newcourse_code
  //     }
  //   })
  // }

  // getSubject4(event: any) {
  
  //   this.withoutCodeSub4 = event.target.value

  // }

  // getCourse5(value) {

  //   this.subjectName5 = value
  //   var count = 0
  //   this.newcourse_code = [];
  //   this.course_code6.forEach(element => {
  //     count++
  //     if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id']) {

  //     } else {

  //       this.newcourse_code.push(element)

  
  //     }

  //     if (count == this.course_code6.length) {
  //       this.course_code6 = [];
  //       this.course_code6 = this.newcourse_code
  //     }
  //   })
  // }

  // getSubject5(event: any) {
  
  //   this.withoutCodeSub5 = event.target.value

  // }

  // getCourse6(value) {

  //   this.subjectName6 = value
  //   var count = 0
  //   this.newcourse_code = [];
  //   this.course_code7.forEach(element => {
  //     count++
  //     if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id'] || element['id'] == this.subjectName6['id']) {

  //     } else {

  //       this.newcourse_code.push(element)

  
  //     }

  //     if (count == this.course_code7.length) {
  //       this.course_code7 = [];
  //       this.course_code7 = this.newcourse_code
  //     }
  //   })
  // }

  // getSubject6(event: any) {
  
  //   this.withoutCodeSub6 = event.target.value

  // }

  // getCourse7(value) {

  //   this.subjectName7 = value
  //   var count = 0
  //   this.newcourse_code = [];
  //   this.course_code8.forEach(element => {
  //     count++
  //     if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id'] || element['id'] == this.subjectName6['id'] || element['id'] == this.subjectName7['id']) {

  //     } else {

  //       this.newcourse_code.push(element)

  
  //     }

  //     if (count == this.course_code8.length) {
  //       this.course_code8 = [];
  //       this.course_code8 = this.newcourse_code
  //     }
  //   })
  // }

  // getSubject8(event: any) {
  
  //   this.withoutCodeSub8 = event.target.value

  // }
  // getCourse8(value) {

  //   this.subjectName8 = value
  //   // if(value.prac == 'yes'){
  
  //   //   this.prac_hour8 = value.Lec_per_Week
  //   //   this.lec_per_week8 = '-'
  //   // }else{
  //   //   this.lec_per_week8 = value.Lec_per_Week
  //   //   this.prac_hour8 = '-'
  
  //   // }
  // }
  // getSubject9(event: any) {
  
  //   this.withoutCodeSub9 = event.target.value

  // }
  // getCourse10(value) {

  //   this.subjectName10 = value
  //   // if(value.prac == 'yes'){
  
  //   //   this.prac_hour10 = value.Lec_per_Week
  //   //   this.lec_per_week10 = '-'
  //   // }else{
  //   //   this.lec_per_week10 = value.Lec_per_Week
  //   //   this.prac_hour10 = '-'
  
  //   // }
  // }

  // getSubject10(event: any) {
  
  //   this.withoutCodeSub10 = event.target.value

  // }
  // getCourse9(value) {

  //   this.subjectName9 = value
  //   // if(value.prac == 'yes'){
  
  //   //   this.prac_hour9 = value.Lec_per_Week
  //   //   this.lec_per_week9 = '-'
  //   // }else{
  //   //   this.lec_per_week9 = value.Lec_per_Week
  //   //   this.prac_hour9 = '-'
  
  //   // }
  // }

  // getSubject7(event: any) {
  
  //   this.withoutCodeSub7 = event.target.value

  // }

  getCourse(value) {
    
    //this.filterText = "";
    this.subjectName = value;
    

    var count = 0;
    this.newcourse_code = [];
    this.course_code.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray.push(element);
      }
      count++;
      if (element["id"] == this.subjectName["id"]) {
        
      } else {
        
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code.length) {
        this.course_code = this.newcourse_code;
      }
    });
    //this.filterPlaceholder = "Search";
    // this.adminApi.getAllCourse(value).subscribe((data)=>{
    //   this.courses = data['data'];
    // })
    // this.filterInput
    //   .valueChanges
    //   .debounceTime(200)
    //   .subscribe(term => {
    //   this.filterText = term;
    // });
  }

  getSubject(event: any) {
    
    this.withoutCodeSub = event.target.value;
    for (let a of this.course_code2) {
     
      if (a.Course_code == this.withoutCodeSub) {
        
        this.subjectName = a;
      }
    }
    if (this.subjectName) {
      
    } else {
      
    }
  }

  getCourse2(value) {
    
    //this.filterText = "";
    this.subjectName2 = value;
    this.course_code2.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray2.push(element);
      }
    });
    
    var count = 0;
    this.newcourse_code = [];
    this.course_code3.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"]
      ) {
        
      } else {
        
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code3.length) {
        this.course_code3 = [];
        this.course_code3 = this.newcourse_code;
      }
    });
  }

  getSubject2(event: any) {
    
    this.withoutCodeSub2 = event.target.value;
    for (let a of this.course_code) {
     
      if (a.Course_code == this.withoutCodeSub2) {
        
        this.subjectName2 = a;
      }
    }
  }

  getCourse3(value) {
    this.subjectName3 = value;
    this.course_code3.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray3.push(element);
      }
    });
    

    var count = 0;
    this.newcourse_code = [];
    this.course_code4.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"]
      ) {
        
      } else {
        
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code4.length) {
        this.course_code4 = [];
        this.course_code4 = this.newcourse_code;
      }
    });
  }

  getSubject3(event: any) {
    this.withoutCodeSub3 = event.target.value;
    for (let a of this.course_code3) {
     
      if (a.Course_code == this.withoutCodeSub3) {
        this.subjectName3 = a;
      }
    }
  }

  getCourse4(value) {
    this.subjectName4 = value;
    this.course_code4.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray4.push(element);
      }
    });
    

    var count = 0;
    this.newcourse_code = [];
    this.course_code5.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"] ||
        element["id"] == this.subjectName4["id"]
      ) {
      } else {
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code5.length) {
        this.course_code5 = [];
        this.course_code5 = this.newcourse_code;
      }
    });
  }

  getSubject4(event: any) {
   
    this.withoutCodeSub4 = event.target.value;
    for (let a of this.course_code4) {
     
      if (a.Course_code == this.withoutCodeSub4) {
       
        this.subjectName4 = a;
      }
    }
  }

  getCourse5(value) {
    this.subjectName5 = value;
    this.course_code5.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray5.push(element);
      }
    });
    

    var count = 0;
    this.newcourse_code = [];
    this.course_code6.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"] ||
        element["id"] == this.subjectName4["id"] ||
        element["id"] == this.subjectName5["id"]
      ) {
      } else {
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code6.length) {
        this.course_code6 = [];
        this.course_code6 = this.newcourse_code;
      }
    });
  }

  getSubject5(event: any) {
    
    this.withoutCodeSub5 = event.target.value;
    for (let a of this.course_code5) {
     
      if (a.Course_code == this.withoutCodeSub5) {
        
        this.subjectName5 = a;
      }
    }
  }

  getCourse6(value) {
    this.subjectName6 = value;
    this.course_code6.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray6.push(element);
      }
    });
   
      

    var count = 0;
    this.newcourse_code = [];
    this.course_code7.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"] ||
        element["id"] == this.subjectName4["id"] ||
        element["id"] == this.subjectName5["id"] ||
        element["id"] == this.subjectName6["id"]
      ) {
      } else {
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code7.length) {
        this.course_code7 = [];
        this.course_code7 = this.newcourse_code;
      }
    });
  }

  getSubject6(event: any) {
    
    this.withoutCodeSub6 = event.target.value;
    for (let a of this.course_code6) {
     
      if (a.Course_code == this.withoutCodeSub6) {
        
        this.subjectName6 = a;
      }
    }
  }

  getCourse7(value) {
    this.subjectName7 = value;
    this.course_code7.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray7.push(element);
      }
    });
    

    var count = 0;
    this.newcourse_code = [];
    this.course_code8.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"] ||
        element["id"] == this.subjectName4["id"] ||
        element["id"] == this.subjectName5["id"] ||
        element["id"] == this.subjectName6["id"] ||
        element["id"] == this.subjectName7["id"]
      ) {
      } else {
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code8.length) {
        this.course_code8 = [];
        this.course_code8 = this.newcourse_code;
      }
    });
  }

  getSubject8(event: any) {
   
    this.withoutCodeSub8 = event.target.value;
    for (let a of this.course_code8) {
     
      if (a.Course_code == this.withoutCodeSub8) {
       
        this.subjectName8 = a;
      }
    }
  }
  getCourse8(value) {
    this.subjectName8 = value;
    this.course_code8.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray8.push(element);
      }
    });
    
  }
  getSubject9(event: any) {
    
    this.withoutCodeSub9 = event.target.value;
    for (let a of this.course_code9) {
     
      if (a.Course_code == this.withoutCodeSub9) {
        
        this.subjectName9 = a;
      }
    }
  }
  getCourse10(value) {
    this.subjectName10 = value;
    this.course_code10.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray10.push(element);
      }
    });
    
  }

  getSubject10(event: any) {
    
    this.withoutCodeSub10 = event.target.value;
    for (let a of this.course_code10) {
     
      if (a.Course_code == this.withoutCodeSub10) {
        
        this.subjectName10 = a;
      }
    }
  }
  getCourse9(value) {
    this.subjectName9 = value;
    this.course_code9.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray9.push(element);
      }
    });
    
  }

  getSubject7(event: any) {
    
    this.withoutCodeSub7 = event.target.value;
    for (let a of this.course_code7) {
     
      if (a.Course_code == this.withoutCodeSub7) {
       
        this.subjectName7 = a;
      }
    }
  }

  editDropdown(){
    this.showcodeDropdown = true
    this.preEditFirst = true;
    this.editShow1 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
  .subscribe(
    (data: any) => { 
      
      if(data['status'] == 200){
       // this.autocheck = false
        this.course_code2 = data['data']
        this.filterText2 = "";
          this.filterInput2
          .valueChanges
          .debounceTime(200)
          .subscribe(term => {
          this.filterText2 = term;
          //this.filterText2 = term;
        });
        
     
        
      }else{

      }
  });
  }

  editDropdown2(){
    
    
    this.showcodeDropdown2 = true
    this.preEditSecond = true;
    this.editShow2 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText = "";
          this.course_code = info['data'];
          
          this.filterInput
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText = term;
          });
          
        }else{

        }
  });
  }

  editDropdown3(){
    this.showcodeDropdown3 = true
    this.preEditThird = true;
    this.editShow3 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText3 = "";
          this.course_code3 = info['data'];
          
          this.filterInput3
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText3 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown4(){
    this.showcodeDropdown4 = true
    this.preEditFourth = true;
    this.editShow4 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText4 = "";
          this.course_code4 = info['data'];
          
          this.filterInput3
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText4 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown5(){
    this.showcodeDropdown5 = true
    this.preEditFifth = true;
    this.editShow5 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText5 = "";
          this.course_code5 = info['data'];
          
          this.filterInput5
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText5 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown6(){
    this.showcodeDropdown6 = true
    this.preEditSixth = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText6 = "";
          this.course_code6 = info['data'];
          
          this.filterInput6
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText6 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown7(){
    this.showcodeDropdown7 = true
    this.preEditSeventh = true;
    this.editShow7 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText7 = "";
          this.course_code7 = info['data'];
          
          this.filterInput7
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText7 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown8(){
    this.showcodeDropdown8 = true
    this.preEditEight = true;
    this.editShow8 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText8 = "";
          this.course_code8 = info['data'];
          
          this.filterInput8
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText8 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown9(){
    this.showcodeDropdown9 = true
    this.preEditNinth = true;
    this.editShow9 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText9 = "";
          this.course_code9 = info['data'];
          
          this.filterInput9
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText9 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown10(){
    this.preEditTenth = true;
    this.showcodeDropdown10 = true
    this.editShow10 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText10 = "";
          this.course_code10 = info['data'];
          
          this.filterInput10
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText10 = term;
          });
          
        }else{

        }
  });
  }
  setSubject1value(value){
    this.edu_form.controls.subjectFirstCtrl.setValue(value)
  }

  setSubject2value(value){
    this.edu_form.controls.subjectSecondCtrl.setValue(value)
  }


  setSubject3value(value){
    this.edu_form.controls.subjectThirdCtrl.setValue(value)
  }
  setSubject4value(value){
    this.edu_form.controls.subjectFourthCtrl.setValue(value)
  }
  setSubject5value(value){
    this.edu_form.controls.subjectFifthCtrl.setValue(value)
  }

  setSubject6value(value){
    this.edu_form.controls.subjectSixthCtrl.setValue(value)
  }

  setSubject7value(value){
    this.edu_form.controls.subjectSeventhCtrl.setValue(value)
  }

  setSubject8value(value){
    this.edu_form.controls.subjectEighthCtrl.setValue(value)
  }

  setSubject9value(value){
    this.edu_form.controls.subjectNinthCtrl.setValue(value)
  }

  setSubject10value(value){
    this.edu_form.controls.subjectTenthCtrl.setValue(value)
  }
  
  showContactDetails(){
    this.confirmationService.confirm({
      message: 'Email - lsraheja@etranscript.in &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp;'+' Whatsapp -  022 2287 6115'  ,
      header: 'Please contact the admin on ',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
                
      },
      reject: () => {
        
      }
    });
  }
  onDeleteSubject(no){
    

    this.api.deleteRecords(this.user_id,this.edu_id,no)
    .subscribe(data => {
      if(data["status"]==200){
        this.getEduDetails();
        this.toasterService.success("Deleted successfully");
      }
    },
    (err)=>console.error(err)
    );
  }


  saveEdu() {
    
    this.courseValidation = true;
    this.collegeYearValidation = true;
    this.semesterValidation = true;
    this.monthValidation = true;
    this.yearValidation = true;
    this.attemptValidation = true;
    this.instructionValidation = true;
    this.endYearValidation = true;

    if(this.edu_form.controls.semesterCtrl.value){
      if(this.edu_form.controls.endmonthCtrl.value){
        this.startmonth = this.edu_form.controls.endmonthCtrl.value
      }else{
        if(this.edu_form.controls.semesterCtrl.value == 'I' || this.edu_form.controls.semesterCtrl.value ==  'III' || this.edu_form.controls.semesterCtrl.value == 'V'){
          this.startmonth = 'June'
        }else{
          this.startmonth =  'November'
        }
      }
      
    }
    
    if (this.edu_form.valid == false) {
      
      this.edu_form.controls.courseNameCtrl.markAsDirty();
      this.edu_form.controls.overAllGradeCtrl.markAsDirty();
      this.edu_form.controls.overAllgpasgpiCtrl.markAsDirty();
      //this.edu_form.controls.subjectFirstCtrl.markAsDirty();
      this.edu_form.controls.creditsEarnedCFirstCtrl.markAsDirty();
      // this.edu_form.controls.courseCreditsFirstCtrl.markAsDirty();
      this.edu_form.controls.gradeFirstCtrl.markAsDirty();
      this.edu_form.controls.gradepointsFirstCtrl.markAsDirty();
      this.edu_form.controls.gradecreditsFirstCtrl.markAsDirty();
      this.edu_form.controls.seatNumberCtrl.markAsDirty();
      // this.edu_form.controls.subjectSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondOutCtrl.markAsDirty();
      // this.edu_form.controls.gradeSecondCtrl.markAsDirty();
      // this.edu_form.controls.gradepointsSecondCtrl.markAsDirty();
      // this.edu_form.controls.gradecreditsSecondCtrl.markAsDirty();
      // this.edu_form.controls.subjectThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdOutCtrl.markAsDirty();
      // this.edu_form.controls.gradeThirdCtrl.markAsDirty();
      // this.edu_form.controls.gradepointsThirdCtrl.markAsDirty();
      // this.edu_form.controls.gradecreditsThirdCtrl.markAsDirty();
      // this.edu_form.controls.subjectFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthOutCtrl.markAsDirty();
      // this.edu_form.controls.gradeFourthCtrl.markAsDirty();
      // this.edu_form.controls.gradepointsFourthCtrl.markAsDirty();
      // this.edu_form.controls.gradecreditsFourthCtrl.markAsDirty();
      this.edu_form.controls.instructionCtrl.markAsDirty();
      this.edu_form.controls.totalCCtrl.markAsDirty();
      this.edu_form.controls.totalCnGCtrl.markAsDirty();

      if (this.edu_form.controls.instructionCtrl.value === null || this.edu_form.controls.instructionCtrl.value === '' || this.edu_form.controls.instructionCtrl.value === undefined) {
        
        this.instructionValidation = false;
      } else {
        
        this.instructionValidation = true;
      }

      if (this.edu_form.controls.courseNameCtrl.value === null || this.edu_form.controls.courseNameCtrl.value === '' || this.edu_form.controls.courseNameCtrl.value === undefined) {
        
        this.courseValidation = false;
      } else {
        
        this.courseValidation = true;
      }

      if (this.edu_form.controls.collegeYearCtrl.value === null || this.edu_form.controls.collegeYearCtrl.value === '' || this.edu_form.controls.collegeYearCtrl.value === undefined) {
        
        this.collegeYearValidation = false;
      } else {
        
        this.collegeYearValidation = true;
      }

      if (this.edu_form.controls.semesterCtrl.value === null || this.edu_form.controls.semesterCtrl.value === '' || this.edu_form.controls.semesterCtrl.value === undefined) {
        
        this.semesterValidation = false;
      } else {
        
        this.semesterValidation = true;
      }

      if (this.edu_form.controls.monthCtrl.value === null || this.edu_form.controls.monthCtrl.value === '' || this.edu_form.controls.monthCtrl.value === undefined) {
        
        this.monthValidation = false;
      } else {
        
        this.monthValidation = true;
      }

      if (this.edu_form.controls.yearCtrl.value === null || this.edu_form.controls.yearCtrl.value === '' || this.edu_form.controls.yearCtrl.value === undefined) {
        
        this.yearValidation = false;
      } else {
        
        this.yearValidation = true;
      }

      // if(this.edu_form.controls.endmonthCtrl.value === null || this.edu_form.controls.endmonthCtrl.value ==='' || this.edu_form.controls.endmonthCtrl.value ===undefined){
      //   this.endmonthValidation = false;
      // }else {
      //   this.endmonthValidation = true;
      // }

      // if(this.edu_form.controls.endyearCtrl.value === null || this.edu_form.controls.endyearCtrl.value ==='' || this.edu_form.controls.endyearCtrl.value ===undefined){
      //   this.endYearValidation = false;
      // }else {
      //   this.endYearValidation = true;
      // }
    } else {
      
      
      var edu_data = {
        courseName: this.edu_form.controls.courseNameCtrl.value,
        collegeYear: this.edu_form.controls.collegeYearCtrl.value,
        semester: this.edu_form.controls.semesterCtrl.value,
        month: this.edu_form.controls.monthCtrl.value,
        year: this.edu_form.controls.yearCtrl.value,
        endmonth: this.startmonth ? this.startmonth : this.edu_form.controls.endmonthCtrl.value,
        startYear: this.startYear ? this.startYear : this.edu_form.controls.startyearCtrl.value,
        endYear: this.edu_form.controls.endyearCtrl.value,
        overAllGrade: this.edu_form.controls.overAllGradeCtrl.value.toUpperCase(),
        overall_gpa_sgpi: this.edu_form.controls.overAllgpasgpiCtrl.value,
        subjectFirst: this.subjectName ? this.subjectName['Course_Subject_name'] : this.withoutCodeSub ? this.withoutCodeSub:this.edu_form.controls.subjectFirstCtrl.value,
        subjectPreFirst : this.edu_form.controls.subjectFirstCtrl.value,
        //subjectFirst : this.edu_form.controls.subjectFirstCtrl.value,
        marks_obt_First: this.edu_form.controls.markObtFirstCtrl.value,
        // marks_out_First: this.edu_form.controls.markFirstOutCtrl.value,
        markFirst: this.edu_form.controls.gradeFirstCtrl.value.toUpperCase(),
        grade_points_First: this.edu_form.controls.gradepointsFirstCtrl.value,
        grade_credits_First: this.edu_form.controls.gradecreditsFirstCtrl.value,
        subjectPreSecond : this.edu_form.controls.subjectSecondCtrl.value,
        subjectSecond: this.subjectName2 ? this.subjectName2['Course_Subject_name'] : this.withoutCodeSub2,
        marks_obt_Second: this.edu_form.controls.markObtSecondCtrl.value,
        marks_out_Second: this.edu_form.controls.markSecondOutCtrl.value,
        markSecond: this.edu_form.controls.gradeSecondCtrl.value.toUpperCase(),
        grade_points_Second: this.edu_form.controls.gradepointsSecondCtrl.value,
        grade_credits_Second: this.edu_form.controls.gradecreditsSecondCtrl.value,
        subjectThird: this.subjectName3 ? this.subjectName3['Course_Subject_name'] : this.withoutCodeSub3,
        subjectPreThird : this.edu_form.controls.subjectThirdCtrl.value,
        marks_obt_Third: this.edu_form.controls.markObtThirdCtrl.value,
        marks_out_Third: this.edu_form.controls.markThirdOutCtrl.value,
        markThird: this.edu_form.controls.gradeThirdCtrl.value.toUpperCase(),
        grade_points_Third: this.edu_form.controls.gradepointsThirdCtrl.value,
        grade_credits_Third: this.edu_form.controls.gradecreditsThirdCtrl.value,
        subjectFourth: this.subjectName4 ? this.subjectName4['Course_Subject_name'] : this.withoutCodeSub4,
        subjectPreFourth : this.edu_form.controls.subjectFourthCtrl.value,
        marks_obt_Fourth: this.edu_form.controls.markObtFourthCtrl.value,
        marks_out_Fourth: this.edu_form.controls.markFourthOutCtrl.value,
        markFourth: this.edu_form.controls.gradeFourthCtrl.value.toUpperCase(),
        grade_points_Fourth: this.edu_form.controls.gradepointsFourthCtrl.value,
        grade_credits_Fourth: this.edu_form.controls.gradecreditsFourthCtrl.value,
        subjectFifth: this.subjectName5 ? this.subjectName5['Course_Subject_name'] : this.withoutCodeSub5,
        subjectPreFifth : this.edu_form.controls.subjectFifthCtrl.value,
        marks_obt_Fifth: this.edu_form.controls.markObtFifthCtrl.value,
        marks_out_Fifth: this.edu_form.controls.markFifthOutCtrl.value,
        markFifth: this.edu_form.controls.gradeFifthCtrl.value.toUpperCase(),
        grade_points_Fifth: this.edu_form.controls.gradepointsFifthCtrl.value,
        grade_credits_Fifth: this.edu_form.controls.gradecreditsFifthCtrl.value,
        subjectPreSixth : this.edu_form.controls.subjectSixthCtrl.value,
        subjectSixth: this.subjectName6 ? this.subjectName6['Course_Subject_name'] : this.withoutCodeSub6,
        marks_obt_Six: this.edu_form.controls.markObtSixthCtrl.value,
        marks_out_Six: this.edu_form.controls.markSixthOutCtrl.value,
        markSixth: this.edu_form.controls.gradeSixthCtrl.value.toUpperCase(),
        grade_points_Six: this.edu_form.controls.gradepointsSixthCtrl.value,
        grade_credits_Six: this.edu_form.controls.gradecreditsSixthCtrl.value,
        subjectSeventh: this.subjectName7 ? this.subjectName7['Course_Subject_name'] : this.withoutCodeSub7,
        subjectPreSeventh : this.edu_form.controls.subjectSeventhCtrl.value,
        marks_obt_Seventh: this.edu_form.controls.markObtSeventhCtrl.value,
        marks_out_Seventh: this.edu_form.controls.markSeventhOutCtrl.value,
        markSeventh: this.edu_form.controls.gradeSeventhCtrl.value.toUpperCase(),
        grade_points_Seventh: this.edu_form.controls.gradepointsSeventhCtrl.value,
        grade_credits_Seventh: this.edu_form.controls.gradecreditsSeventhCtrl.value,
        subjectEighth: this.subjectName8 ? this.subjectName8['Course_Subject_name'] : this.withoutCodeSub8,
        subjectPreEighth : this.edu_form.controls.subjectEighthCtrl.value,
        marks_obt_Eighth: this.edu_form.controls.markObtEightCtrl.value,
        marks_out_Eighth: this.edu_form.controls.markEighthOutCtrl.value,
        markEighth: this.edu_form.controls.gradeEighthCtrl.value.toUpperCase(),
        grade_points_Eighth: this.edu_form.controls.gradepointsEighthCtrl.value,
        grade_credits_Eighth: this.edu_form.controls.gradecreditsEighthCtrl.value,
        subjectNinth: this.subjectName9 ? this.subjectName9['Course_Subject_name'] : this.withoutCodeSub9,
        subjectPreNinth : this.edu_form.controls.subjectNinthCtrl.value,
        marks_obt_Ninth: this.edu_form.controls.markObtNinthCtrl.value,
        marks_out_Ninth: this.edu_form.controls.markNinthOutCtrl.value,
        markNinth: this.edu_form.controls.gradeNinthCtrl.value.toUpperCase(),
        grade_points_Ninth: this.edu_form.controls.gradepointsNinthCtrl.value,
        grade_credits_Ninth: this.edu_form.controls.gradecreditsNinthCtrl.value,
        subjectTenth: this.subjectName10 ? this.subjectName10['Course_Subject_name'] : this.withoutCodeSub10,
        subjectPreTenth : this.edu_form.controls.subjectTenthCtrl.value,
        marks_obt_Tenth: this.edu_form.controls.markObtTenthCtrl.value,
        marks_out_Tenth: this.edu_form.controls.markTenthOutCtrl.value,
        markTenth: this.edu_form.controls.gradeTenthCtrl.value.toUpperCase(),
        grade_points_Tenth: this.edu_form.controls.gradepointsTenthCtrl.value,
        grade_credits_Tenth: this.edu_form.controls.gradecreditsTenthCtrl.value,
        user_id: this.user_id,
        medium_instruction: this.edu_form.controls.instructionCtrl.value,
        id: this.edu_id,
        special_instruction: this.specialInstruction ? this.specialInstruction : this.specI,
        final_grade_special_instruction: this.GradespecialInstruction ? this.GradespecialInstruction : this.DradespecI,
        // special_instruction : this.edu_form.controls.specialInstrctionCtrl.value,
        // final_grade_special_instruction : this.edu_form.controls.finalgradespecialInstrctionCtrl.value,
        total_weeks: this.edu_form.controls.totalweeksCtrl.value,
        total_course_credits : this.edu_form.controls.totalCourseCreditsCtrl.value,
        th_First: this.edu_form.controls.thFirstCtrl.value.toUpperCase(),
        th_Second: this.edu_form.controls.thSecondCtrl.value.toUpperCase(),
        th_Third: this.edu_form.controls.thThirdCtrl.value.toUpperCase(),
        th_Fourth: this.edu_form.controls.thFourthCtrl.value.toUpperCase(),
        th_Fifth: this.edu_form.controls.thFifthCtrl.value.toUpperCase(),
        th_Sixth: this.edu_form.controls.thSixthCtrl.value.toUpperCase(),
        th_Seventh: this.edu_form.controls.thSeventhCtrl.value.toUpperCase(),
        th_Eight: this.edu_form.controls.thEightCtrl.value.toUpperCase(),
        th_Ninth: this.edu_form.controls.thNinthCtrl.value.toUpperCase(),
        th_Tenth: this.edu_form.controls.thTenthCtrl.value.toUpperCase(),

        credits_Earned_c_First: this.edu_form.controls.creditsEarnedCFirstCtrl.value,
        credits_Earned_c_Second: this.edu_form.controls.creditsEarnedCSecondCtrl.value,
        credits_Earned_c_Third: this.edu_form.controls.creditsEarnedCThirdCtrl.value,
        credits_Earned_c_Fourth: this.edu_form.controls.creditsEarnedCFourthCtrl.value,
        credits_Earned_c_Fifth: this.edu_form.controls.creditsEarnedCFifthCtrl.value,
        credits_Earned_c_Sixth: this.edu_form.controls.creditsEarnedCSixthCtrl.value,
        credits_Earned_c_Seven: this.edu_form.controls.creditsEarnedCSevenCtrl.value,
        credits_Earned_c_Eight: this.edu_form.controls.creditsEarnedCEightCtrl.value,
        credits_Earned_c_Ninth: this.edu_form.controls.creditsEarnedCNinthCtrl.value,
        credits_Earned_c_tenth: this.edu_form.controls.creditsEarnedCtehthCtrl.value,

        // total marks
        first_total_marks: this.edu_form.controls.firstTotalMarksCtrl.value,
        second_total_marks: this.edu_form.controls.secondTotalMarksCtrl.value,
        third_total_marks: this.edu_form.controls.thirdTotalMarksCtrl.value,
        fourth_total_marks: this.edu_form.controls.fourthTotalMarksCtrl.value,
        fifth_total_marks: this.edu_form.controls.fifthTotalMarksCtrl.value,
        sixth_total_marks: this.edu_form.controls.sixthTotalMarksCtrl.value,
        seventh_total_marks: this.edu_form.controls.seventhTotalMarksCtrl.value,
        eight_total_marks: this.edu_form.controls.eightTotalMarksCtrl.value,
        nine_total_marks: this.edu_form.controls.nineTotalMarksCtrl.value,
        ten_total_marks: this.edu_form.controls.tenTotalMarksCtrl.value,
        over_all_total: this.edu_form.controls.overAllTotalCtrl.value,
       

        ia_First: this.edu_form.controls.iaFirstCtrl.value.toUpperCase()?this.edu_form.controls.iaFirstCtrl.value:"--",
        ia_Second: this.edu_form.controls.iaSecondCtrl.value.toUpperCase()?this.edu_form.controls.iaSecondCtrl.value:"--",
        ia_Third: this.edu_form.controls.iaThirdCtrl.value.toUpperCase()?this.edu_form.controls.iaThirdCtrl.value:"--",
        ia_Fourth: this.edu_form.controls.iaFourthCtrl.value.toUpperCase()?this.edu_form.controls.iaFourthCtrl.value:"--",
        ia_Fifth: this.edu_form.controls.iaFifthCtrl.value.toUpperCase()?this.edu_form.controls.iaFifthCtrl.value:"--",
        ia_Sixth: this.edu_form.controls.iaSixthCtrl.value.toUpperCase()?this.edu_form.controls.iaSixthCtrl.value:"--",
        ia_Seventh: this.edu_form.controls.iaSeventhCtrl.value.toUpperCase()?this.edu_form.controls.iaSeventhCtrl.value:"--",
        ia_Eight: this.edu_form.controls.iaEightCtrl.value.toUpperCase()?this.edu_form.controls.iaEightCtrl.value:"--",
        ia_Ninth: this.edu_form.controls.iaNinthCtrl.value.toUpperCase()?this.edu_form.controls.iaNinthCtrl.value:"--",
        ia_Tenth: this.edu_form.controls.iaTenthCtrl.value.toUpperCase()?this.edu_form.controls.iaTenthCtrl.value:"--",

        max_marks_first : this.edu_form.controls.maxMarksFirstCtrl.value,
        max_marks_second : this.edu_form.controls.maxMarksSecondCtrl.value,
        max_marks_third : this.edu_form.controls.maxMarksThirdCtrl.value,
        max_marks_fourth : this.edu_form.controls.maxMarksFourthCtrl.value,
        max_marks_fifth : this.edu_form.controls.maxMarksFifthCtrl.value,
        max_marks_sixth : this.edu_form.controls.maxMarksSixthCtrl.value,
        max_marks_seventh : this.edu_form.controls.maxMarksSeventhCtrl.value,
        max_marks_eight : this.edu_form.controls.maxMarksEightCtrl.value,
        max_marks_ninth : this.edu_form.controls.maxMarksNinthCtrl.value,
        max_marks_tenth : this.edu_form.controls.maxMarksTenthCtrl.value, 

        min_marks_first : this.edu_form.controls.minMarksFirstCtrl.value,
        min_marks_second : this.edu_form.controls.minMarksSecondCtrl.value,
        min_marks_third : this.edu_form.controls.minMarksThirdCtrl.value,
        min_marks_fourth : this.edu_form.controls.minMarksFourthCtrl.value,
        min_marks_fifth : this.edu_form.controls.minMarksFifthCtrl.value,
        min_marks_sixth : this.edu_form.controls.minMarksSixthCtrl.value,
        min_marks_seventh : this.edu_form.controls.minMarksSeventhCtrl.value,
        min_marks_eight : this.edu_form.controls.minMarksEightCtrl.value,
        min_marks_ninth : this.edu_form.controls.minMarksNinthCtrl.value,
        min_marks_tenth : this.edu_form.controls.minMarksTenthCtrl.value,
        
        sem_end_first :this.edu_form.controls.semEndFirstCtrl.value,
        sem_end_second :this.edu_form.controls.semEndSecondCtrl.value,
        sem_end_third :this.edu_form.controls.semEndThirdCtrl.value,
        sem_end_fourth :this.edu_form.controls.semEndFourthCtrl.value,
        sem_end_fifth :this.edu_form.controls.semEndFifthCtrl.value,
        sem_end_sixth :this.edu_form.controls.semEndSixthCtrl.value,
        sem_end_seventh :this.edu_form.controls.semEndSeventhCtrl.value,
        sem_end_eight :this.edu_form.controls.semEndEightCtrl.value,
        sem_end_ninth :this.edu_form.controls.semEndNinthCtrl.value,
        sem_end_tenth :this.edu_form.controls.semEndTenthCtrl.value,

        // overall_marks_obt : this.edu_form.controls.overmarksobtCtrl.value,
        overall_marks_out : this.edu_form.controls.overmarksoutCtrl.value,

        
        //months_taken_tenth: this.subjectName10 ? (this.edu_form.controls.monthstakenCtrl10.value ? this.edu_form.controls.monthstakenCtrl10.value : '4') : '',
        totalC: this.edu_form.controls.totalCCtrl.value,
        totalCnG: this.edu_form.controls.totalCnGCtrl.value,
        overall_CGPA: this.edu_form.controls.OverallCGPACtrl.value,
        overAllYearlyGrade: this.edu_form.controls.finalGradeCtrl.value.toUpperCase(),
        specialisation : this.edu_form.controls.SpecialisationCtrl.value,
        seat_number : this.edu_form.controls.seatNumberCtrl.value,
        sgpi_gpa: 'sgpi',

        result : this.edu_form.controls.resultCtrl.value,
        remarks : this.edu_form.controls.remarksCtrl.value,
        total_max_marks : this.edu_form.controls.totalMaxMarksCtrl.value,
        overall_marks_obt : this.edu_form.controls.totalMarksObtCtrl.value,

        internal_Marks : this.edu_form.controls.internalMarksCtrl.value,
        internal_Marks_Second : this.edu_form.controls.internalMarksSecondCtrl.value,
        internal_Marks_Third : this.edu_form.controls.internalMarksThirdCtrl.value,
        internal_Marks_Fourth : this.edu_form.controls.internalMarksFourthCtrl.value,
        internal_Marks_Fifth : this.edu_form.controls.internalMarksFifthCtrl.value,
        internal_Marks_Sixth : this.edu_form.controls.internalMarksSixthCtrl.value,
        internal_Marks_Seventh : this.edu_form.controls.internalMarksSeventhCtrl.value,
        internal_Marks_Eight : this.edu_form.controls.internalMarksEightCtrl.value,
        internal_Marks_Nine : this.edu_form.controls.internalMarksNineCtrl.value,
        internal_Marks_Ten : this.edu_form.controls.internalMarksTenCtrl.value,

        // ba sgpi
        min_internal_marks_first : this.edu_form.controls.minInternalMarksFirstCtrl.value,

        special_instruction1 : this.special_instruction1,
        special_instruction2 : this.special_instruction2,
        special_instruction3 : this.special_instruction3,
        special_instruction4 : this.special_instruction4,
        special_instruction5 : this.special_instruction5,
        special_instruction6 : this.special_instruction6,
        special_instruction7 : this.special_instruction7,

        course_code_first: this.subjectName
          ? this.subjectName["Course_code"]
          : this.withoutCodeSub? this.withoutCodeSub:this.edu_form.controls.courseCodeFirstCtrl.value,
        course_code_second: this.subjectName2
          ? this.subjectName2["Course_code"]
          : this.withoutCodeSub2,
        course_code_third: this.subjectName3
          ? this.subjectName3["Course_code"]
          : this.withoutCodeSub3,
        course_code_fourth: this.subjectName4
          ? this.subjectName4["Course_code"]
          : this.withoutCodeSub4,
        course_code_fifth: this.subjectName5
          ? this.subjectName5["Course_code"]
          : this.withoutCodeSub5,
        course_code_sixth: this.subjectName6
          ? this.subjectName6["Course_code"]
          : this.withoutCodeSub6,
        course_code_seventh: this.subjectName7
          ? this.subjectName7["Course_code"]
          : this.withoutCodeSub7,
        course_code_eight: this.subjectName8
          ? this.subjectName8["Course_code"]
          : this.withoutCodeSub8,
        course_code_ninth: this.subjectName9
          ? this.subjectName9["Course_code"]
          : this.withoutCodeSub9,
        course_code_tenth: this.subjectName10
          ? this.subjectName10["Course_code"]
          : this.withoutCodeSub10,

          course_code_edit_first : this.edu_form.controls.courseEdit1Ctrl.value.toUpperCase(),
          course_code_edit_second : this.edu_form.controls.courseEdit2Ctrl.value.toUpperCase(),
          course_code_edit_third : this.edu_form.controls.courseEdit3Ctrl.value.toUpperCase(),
          course_code_edit_fourth : this.edu_form.controls.courseEdit4Ctrl.value.toUpperCase(),
          course_code_edit_fifth : this.edu_form.controls.courseEdit5Ctrl.value.toUpperCase(),
          course_code_edit_sixth : this.edu_form.controls.courseEdit6Ctrl.value.toUpperCase(),
          course_code_edit_seventh : this.edu_form.controls.courseEdit7Ctrl.value.toUpperCase(),
          course_code_edit_eight : this.edu_form.controls.courseEdit8Ctrl.value.toUpperCase(),
          course_code_edit_ninth : this.edu_form.controls.courseEdit9Ctrl.value.toUpperCase(),
          course_code_edit_tenth : this.edu_form.controls.courseEdit10Ctrl.value.toUpperCase(),

          
        subject_edit_First : this.edu_form.controls.subjectEditFirstCtrl.value.toUpperCase(),
        subject_edit_Second : this.edu_form.controls.subjectEditSecondCtrl.value.toUpperCase(),
        subject_edit_Third : this.edu_form.controls.subjectEditThirdCtrl.value.toUpperCase(),
        subject_edit_Fourth : this.edu_form.controls.subjectEditFourthCtrl.value.toUpperCase(),
        subject_edit_Fifth : this.edu_form.controls.subjectEditFifthCtrl.value.toUpperCase(),
        subject_edit_Sixth : this.edu_form.controls.subjectEditSixthCtrl.value.toUpperCase(),
        subject_edit_Seventh : this.edu_form.controls.subjectEditSeventhCtrl.value.toUpperCase(),
        subject_edit_Eight : this.edu_form.controls.subjectEditEightCtrl.value.toUpperCase(),
        subject_edit_Ninth : this.edu_form.controls.subjectEditNinthCtrl.value.toUpperCase(),
        subject_edit_Tenth : this.edu_form.controls.subjectEditTenthCtrl.value.toUpperCase(),

        course_credits_First : this.edu_form.controls.courseCreditsFirstCtrl.value,
        course_credits_Second : this.edu_form.controls.courseCreditsSecondCtrl.value,
        course_credits_Third : this.edu_form.controls.courseCreditsThirdCtrl.value,
        course_credits_Fourth : this.edu_form.controls.courseCreditsFourthCtrl.value,
        course_credits_Fifth : this.edu_form.controls.courseCreditsFifthCtrl.value,
        course_credits_Sixth : this.edu_form.controls.courseCreditsSixthCtrl.value,
        course_credits_Seventh : this.edu_form.controls.courseCreditsSeventhCtrl.value,
        course_credits_Eight : this.edu_form.controls.courseCreditsEightCtrl.value,
        course_credits_Ninth : this.edu_form.controls.courseCreditsNinthCtrl.value,
        course_credits_Tenth : this.edu_form.controls.courseCreditsTenthCtrl.value,
        // course_credits_Third : this.subjectName3 ? this.subjectName3['Credits'] : this.edu_form.controls.courseCreditsThirdCtrl.value,
        // course_credits_Fourth : this.subjectName4 ? this.subjectName4['Credits'] : this.edu_form.controls.courseCreditsFourthCtrl.value,
        // course_credits_Fifth : this.subjectName5 ? this.subjectName5['Credits'] : this.edu_form.controls.courseCreditsFifthCtrl.value,
        // course_credits_Sixth : this.subjectName6 ? this.subjectName6['Credits'] : this.edu_form.controls.courseCreditsSixthCtrl.value,
        // course_credits_Seventh : this.subjectName7 ? this.subjectName7['Credits'] : this.edu_form.controls.courseCreditsSeventhCtrl.value,
        // course_credits_Eight : this.subjectName8 ? this.subjectName8['Credits'] : this.edu_form.controls.courseCreditsEightCtrl.value,
        // course_credits_Ninth : this.subjectName9 ? this.subjectName9['Credits'] : this.edu_form.controls.courseCreditsNinthCtrl.value,
        // course_credits_Tenth : this.subjectName10 ? this.subjectName10['Credits'] : this.edu_form.controls.courseCreditsTenthCtrl.value,

        course_credits_pre_first: this.edu_form.controls.courseCreditsFirstCtrl.value,
        course_credits_pre_second: this.edu_form.controls.courseCreditsSecondCtrl.value,
        course_credits_pre_third : this.edu_form.controls.courseCreditsThirdCtrl.value,
        course_credits_pre_fourth : this.edu_form.controls.courseCreditsFourthCtrl.value,
        course_credits_pre_fifth : this.edu_form.controls.courseCreditsFifthCtrl.value,
        course_credits_pre_sixth : this.edu_form.controls.courseCreditsSixthCtrl.value,
        course_credits_pre_seventh : this.edu_form.controls.courseCreditsSeventhCtrl.value,
        course_credits_pre_eight : this.edu_form.controls.courseCreditsEightCtrl.value,
        course_credits_pre_ninth : this.edu_form.controls.courseCreditsNinthCtrl.value,
        course_credits_pre_tenth : this.edu_form.controls.courseCreditsTenthCtrl.value,
        footnotes : this.edu_form.controls.footnotesCtrl.value,
        sgpiInstruction : this.edu_form.controls.sgpiInstCtrl.value,
        sgpi_sem_I_Details : this.edu_form.controls.sem1sgpidetailsctrl.value,
        sgpi_sem_II_Details : this.edu_form.controls.sem2sgpidetailsctrl.value,
        sgpi_sem_III_Details : this.edu_form.controls.sem3sgpidetailsctrl.value,
        sgpi_sem_IV_Details : this.edu_form.controls.sem4sgpidetailsctrl.value,
        sgpi_sem_V_Details : this.edu_form.controls.sem5sgpidetailsctrl.value,
        stillStdMonth : this.edu_form.controls.stlStdmonthCtrl.value,
        


      }
      
      this.api.setEducationalValues(edu_data)
        .subscribe(
          (data: any) => {
            this.ref.close(data);
            err => console.error(err)
          });
    }
  }

  dismiss() {
    this.ref.close();
  }

  getTotalCredits() {
    this.totalMarks = 0
    
    if (this.edu_form.controls.creditsEarnedCSecondCtrl.value != '' && this.edu_form.controls.creditsEarnedCThirdCtrl.value != '' && this.edu_form.controls.creditsEarnedCFourthCtrl.value != '' && this.edu_form.controls.creditsEarnedCFifthCtrl.value != '' && this.edu_form.controls.creditsEarnedCSixthCtrl.value != '' && this.edu_form.controls.creditsEarnedCSevenCtrl.value != '' && this.edu_form.controls.creditsEarnedCEightCtrl.value != '' && this.edu_form.controls.creditsEarnedCNinthCtrl.value != '' && this.edu_form.controls.creditsEarnedCtehthCtrl.value != '' ) {
      this.totalMarks = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) + Number(this.edu_form.controls.creditsEarnedCEightCtrl.value) + Number(this.edu_form.controls.creditsEarnedCNinthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCtehthCtrl.value))
    
    }
      else if (this.edu_form.controls.creditsEarnedCSecondCtrl.value != '' && this.edu_form.controls.creditsEarnedCThirdCtrl.value != '' && this.edu_form.controls.creditsEarnedCFourthCtrl.value != '' && this.edu_form.controls.creditsEarnedCFifthCtrl.value != '' && this.edu_form.controls.creditsEarnedCSixthCtrl.value != '' && this.edu_form.controls.creditsEarnedCSevenCtrl.value != '' && this.edu_form.controls.creditsEarnedCEightCtrl.value != '' && this.edu_form.controls.creditsEarnedCNinthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) + Number(this.edu_form.controls.creditsEarnedCEightCtrl.value) + Number(this.edu_form.controls.creditsEarnedCNinthCtrl.value))
     
    }
      else if (this.edu_form.controls.creditsEarnedCSecondCtrl.value != '' && this.edu_form.controls.creditsEarnedCThirdCtrl.value != '' && this.edu_form.controls.creditsEarnedCFourthCtrl.value != '' && this.edu_form.controls.creditsEarnedCFifthCtrl.value != '' && this.edu_form.controls.creditsEarnedCSixthCtrl.value != '' && this.edu_form.controls.creditsEarnedCSevenCtrl.value != '' && this.edu_form.controls.creditsEarnedCEightCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) + Number(this.edu_form.controls.creditsEarnedCEightCtrl.value))
      
    } else if (this.edu_form.controls.creditsEarnedCSecondCtrl.value != '' && this.edu_form.controls.creditsEarnedCThirdCtrl.value != '' && this.edu_form.controls.creditsEarnedCFourthCtrl.value != '' && this.edu_form.controls.creditsEarnedCFifthCtrl.value != '' && this.edu_form.controls.creditsEarnedCSixthCtrl.value != '' && this.edu_form.controls.creditsEarnedCSevenCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value))
      
    } else if (this.edu_form.controls.creditsEarnedCSecondCtrl.value != '' && this.edu_form.controls.creditsEarnedCThirdCtrl.value != '' && this.edu_form.controls.creditsEarnedCFourthCtrl.value != '' && this.edu_form.controls.creditsEarnedCFifthCtrl.value != '' && this.edu_form.controls.creditsEarnedCSixthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value))
      
    } else if (this.edu_form.controls.creditsEarnedCSecondCtrl.value != '' && this.edu_form.controls.creditsEarnedCThirdCtrl.value != '' && this.edu_form.controls.creditsEarnedCFourthCtrl.value != '' && this.edu_form.controls.creditsEarnedCFifthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value))
      
    } else if (this.edu_form.controls.creditsEarnedCSecondCtrl.value != '' && this.edu_form.controls.creditsEarnedCThirdCtrl.value != '' && this.edu_form.controls.creditsEarnedCFourthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value))
      
    } else if (this.edu_form.controls.creditsEarnedCSecondCtrl.value != '' && this.edu_form.controls.creditsEarnedCThirdCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value))
      
    } else if (this.edu_form.controls.creditsEarnedCSecondCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value))
      
    }

    // if (this.totalCnG && this.totalMarks) {
    //   this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
    //   this.totalcgpa = Number(this.totalcgpa.toFixed(2))
    // }
  }

  // totalsMarksOut() {
  //   this.totalMarksOut = 0
  //   if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '' && this.edu_form.controls.markSeventhOutCtrl.value != '' && this.edu_form.controls.markEighthOutCtrl.value) {
  //     this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value) + Number(this.edu_form.controls.markSeventhOutCtrl.value) + Number(this.edu_form.controls.markEighthOutCtrl.value))
  //   } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '' && this.edu_form.controls.markSeventhOutCtrl.value != '') {
  //     this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value) + Number(this.edu_form.controls.markSeventhOutCtrl.value))
  //   } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '') {
  //     this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value))
  //   } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '') {
  //     this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value))
  //   } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '') {
  //     this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value))
  //   } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '') {
  //     this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value))
  //   } else if (this.edu_form.controls.markSecondOutCtrl.value != '') {
  //     this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value))
  //   }
  // }

  // hetmarksObt() {
  //   // hetmarksObt
  //   this.creditTotal = 0
  //   if (this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value && this.edu_form.controls.creditsEarnedCSevenCtrl.value && this.edu_form.controls.creditsEarnedCEightCtrl.value && this.edu_form.controls.creditsEarnedCNinthCtrl.value && this.edu_form.controls.creditsEarnedCtehthCtrl.value) {
  //     this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) + Number(this.edu_form.controls.creditsEarnedCEightCtrl.value) + Number(this.edu_form.controls.creditsEarnedCNinthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCtehthCtrl.value))
  //   } else if (this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value && this.edu_form.controls.creditsEarnedCSevenCtrl.value && this.edu_form.controls.creditsEarnedCEightCtrl.value && this.edu_form.controls.creditsEarnedCNinthCtrl.value) {
  //     this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) + Number(this.edu_form.controls.creditsEarnedCEightCtrl.value) + Number(this.edu_form.controls.creditsEarnedCNinthCtrl.value))
  //   } else if (this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value && this.edu_form.controls.creditsEarnedCSevenCtrl.value && this.edu_form.controls.creditsEarnedCEightCtrl.value) {
  //     this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) + Number(this.edu_form.controls.creditsEarnedCEightCtrl.value))
  //   } else if (this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value && this.edu_form.controls.creditsEarnedCSevenCtrl.value) {
  //     this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value))
  //   } else if (this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value) {
  //     this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value))
  //   } else if (this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value) {
  //     this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value))
  //   } else if (this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value) {
  //     this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value))
  //   } else if (this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value) {
  //     this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value))
  //   } else if (this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value) {
  //     this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value))
  //   }

  // }

  // myFunc(){
  //   this.totalMarks = 0
  //   this.totalMarksOut=0
  //   if(this.edu_form.controls.internalMarksCtrl.value && this.edu_form.controls.semEndFirstCtrl.value){
  //     this.totalValue = parseInt(this.edu_form.controls.semEndSecondCtrl.value) + parseInt(this.edu_form.controls.internalMarksCtrl.value)
  //     if(this.totalValue>0){
  //       this.totalMarks = this.totalMarks + this.totalValue;
  //       this.totalMarksOut=this.totalMarksOut+100
  //     }
  //   }
  //   if(this.edu_form.controls.internalMarksSecondCtrl.value && this.edu_form.controls.semEndSecondCtrl.value){
     
  //     this.totalValue2 = parseInt(this.edu_form.controls.internalMarksSecondCtrl.value) + parseInt(this.edu_form.controls.semEndSecondCtrl.value)
  //     if(this.totalValue2>0){
  //       this.totalMarks = this.totalMarks + this.totalValue2;
  //       this.totalMarksOut=this.totalMarksOut+100
  //     }
  //   }

  //   if(this.edu_form.controls.internalMarksThirdCtrl.value && this.edu_form.controls.semEndThirdCtrl.value){
     
  //     this.totalValue3 = parseInt(this.edu_form.controls.internalMarksThirdCtrl.value) + parseInt(this.edu_form.controls.semEndThirdCtrl.value)
  //     if(this.totalValue3>0){
  //       this.totalMarks = this.totalMarks + this.totalValue3;
  //       this.totalMarksOut=this.totalMarksOut+100
  //     }
  //   }
  //   if(this.edu_form.controls.internalMarksFourthCtrl.value && this.edu_form.controls.semEndFourthCtrl.value){
     
  //     this.totalValue4 = parseInt(this.edu_form.controls.internalMarksFourthCtrl.value) + parseInt(this.edu_form.controls.semEndFourthCtrl.value)
  //     if(this.totalValue4>0){
  //       this.totalMarks = this.totalMarks + this.totalValue4;
  //       this.totalMarksOut=this.totalMarksOut+100
  //     }
   
  //   }
  //   if(this.edu_form.controls.internalMarksFifthCtrl.value && this.edu_form.controls.semEndFifthCtrl.value){
     
  //     this.totalValue5 = parseInt(this.edu_form.controls.internalMarksFifthCtrl.value) + parseInt(this.edu_form.controls.semEndFifthCtrl.value)
  //     if(this.totalValue5>0){
  //       this.totalMarks = this.totalMarks + this.totalValue5;
  //       this.totalMarksOut=this.totalMarksOut+100
  //     }
  //   }
  //   if(this.edu_form.controls.internalMarksSixthCtrl.value && this.edu_form.controls.semEndSixthCtrl.value){
     
  //     this.totalValue6 = parseInt(this.edu_form.controls.internalMarksSixthCtrl.value) + parseInt(this.edu_form.controls.semEndSixthCtrl.value)
  //     if(this.totalValue6>0){
  //       this.totalMarks = this.totalMarks + this.totalValue6;
  //       this.totalMarksOut=this.totalMarksOut+100
  //     }
  //   }
  //   if(this.edu_form.controls.internalMarksSeventhCtrl.value && this.edu_form.controls.semEndSeventhCtrl.value){
     
  //     this.totalValue7 = parseInt(this.edu_form.controls.internalMarksSeventhCtrl.value) + parseInt(this.edu_form.controls.semEndSeventhCtrl.value)
  //     if(this.totalValue7>0){
  //       this.totalMarks = this.totalMarks + this.totalValue7;
  //       this.totalMarksOut=this.totalMarksOut+100
  //     }
  //   }
  //   if(this.edu_form.controls.internalMarksEightCtrl.value && this.edu_form.controls.semEndEightCtrl.value){
     
  //     this.totalValue8 = parseInt(this.edu_form.controls.internalMarksEightCtrl.value) + parseInt(this.edu_form.controls.semEndEightCtrl.value)
  //     if(this.totalValue8>0){
  //       this.totalMarks = this.totalMarks + this.totalValue8;
  //       this.totalMarksOut=this.totalMarksOut+100
  //     }
   
  //   }
  //   if(this.edu_form.controls.internalMarksNineCtrl.value && this.edu_form.controls.semEndNinthCtrl.value){
     
  //     this.totalValue9 = parseInt(this.edu_form.controls.internalMarksNineCtrl.value) + parseInt(this.edu_form.controls.semEndNinthCtrl.value)
  //     if(this.totalValue9>0){
  //       this.totalMarks = this.totalMarks + this.totalValue9;
  //       this.totalMarksOut=this.totalMarksOut+100
  //     }
   
  //   }
  //   if(this.edu_form.controls.internalMarksTenCtrl.value && this.edu_form.controls.semEndTenthCtrl.value){
     
  //     this.totalValue10 = parseInt(this.edu_form.controls.internalMarksTenCtrl.value) + parseInt(this.edu_form.controls.semEndTenthCtrl.value)
  //     if(this.totalValue10>0){
  //       this.totalMarks = this.totalMarks + this.totalValue10;
  //       this.totalMarksOut=this.totalMarksOut+100
  //     }
  //   }
   
   
  // }

  myFunc(){
    this.totalMarksmyFunc = 0
    this.totalMarksOutmyFunc=0
    if(this.edu_form.controls.internalMarksCtrl.value && this.edu_form.controls.semEndFirstCtrl.value){
      this.totalValue = parseInt(this.edu_form.controls.semEndFirstCtrl.value) + parseInt(this.edu_form.controls.internalMarksCtrl.value)
      if(this.totalValue>0){
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue;
        this.totalMarksOutmyFunc=this.totalMarksOutmyFunc+100
      }
    }
    if(this.edu_form.controls.internalMarksSecondCtrl.value && this.edu_form.controls.semEndSecondCtrl.value){
     
      this.totalValue2 = parseInt(this.edu_form.controls.internalMarksSecondCtrl.value) + parseInt(this.edu_form.controls.semEndSecondCtrl.value)
      if(this.totalValue2>0){
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue2;
        this.totalMarksOutmyFunc=this.totalMarksOutmyFunc+100
      }
    }

    if(this.edu_form.controls.internalMarksThirdCtrl.value && this.edu_form.controls.semEndThirdCtrl.value){
     
      this.totalValue3 = parseInt(this.edu_form.controls.internalMarksThirdCtrl.value) + parseInt(this.edu_form.controls.semEndThirdCtrl.value)
      if(this.totalValue3>0){
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue3;
        this.totalMarksOutmyFunc=this.totalMarksOutmyFunc+100
      }
    }
    if(this.edu_form.controls.internalMarksFourthCtrl.value && this.edu_form.controls.semEndFourthCtrl.value){
     
      this.totalValue4 = parseInt(this.edu_form.controls.internalMarksFourthCtrl.value) + parseInt(this.edu_form.controls.semEndFourthCtrl.value)
      if(this.totalValue4>0){
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue4;
        this.totalMarksOutmyFunc=this.totalMarksOutmyFunc+100
      }
   
    }
    if(this.edu_form.controls.internalMarksFifthCtrl.value && this.edu_form.controls.semEndFifthCtrl.value){
     
      this.totalValue5 = parseInt(this.edu_form.controls.internalMarksFifthCtrl.value) + parseInt(this.edu_form.controls.semEndFifthCtrl.value)
      if(this.totalValue5>0){
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue5;
        this.totalMarksOutmyFunc=this.totalMarksOutmyFunc+100
      }
    }
    if(this.edu_form.controls.internalMarksSixthCtrl.value && this.edu_form.controls.semEndSixthCtrl.value){
     
      this.totalValue6 = parseInt(this.edu_form.controls.internalMarksSixthCtrl.value) + parseInt(this.edu_form.controls.semEndSixthCtrl.value)
      if(this.totalValue6>0){
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue6;
        this.totalMarksOutmyFunc=this.totalMarksOutmyFunc+100
      }
    }
    if(this.edu_form.controls.internalMarksSeventhCtrl.value && this.edu_form.controls.semEndSeventhCtrl.value){
     
      this.totalValue7 = parseInt(this.edu_form.controls.internalMarksSeventhCtrl.value) + parseInt(this.edu_form.controls.semEndSeventhCtrl.value)
      if(this.totalValue7>0){
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue7;
        this.totalMarksOutmyFunc=this.totalMarksOutmyFunc+100
      }
    }
    if(this.edu_form.controls.internalMarksEightCtrl.value && this.edu_form.controls.semEndEightCtrl.value){
     
      this.totalValue8 = parseInt(this.edu_form.controls.internalMarksEightCtrl.value) + parseInt(this.edu_form.controls.semEndEightCtrl.value)
      if(this.totalValue8>0){
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue8;
        this.totalMarksOutmyFunc=this.totalMarksOutmyFunc+100
      }
   
    }
    if(this.edu_form.controls.internalMarksNineCtrl.value && this.edu_form.controls.semEndNinthCtrl.value){
     
      this.totalValue9 = parseInt(this.edu_form.controls.internalMarksNineCtrl.value) + parseInt(this.edu_form.controls.semEndNinthCtrl.value)
      if(this.totalValue9>0){
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue9;
        this.totalMarksOutmyFunc=this.totalMarksOutmyFunc+100
      }
   
    }
    if(this.edu_form.controls.internalMarksTenCtrl.value && this.edu_form.controls.semEndTenthCtrl.value){
     
      this.totalValue10 = parseInt(this.edu_form.controls.internalMarksTenCtrl.value) + parseInt(this.edu_form.controls.semEndTenthCtrl.value)
      if(this.totalValue10>0){
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue10;
        this.totalMarksOutmyFunc=this.totalMarksOutmyFunc+100
      }
    }
   
   
  }

  getTotalCnG() {
    this.totalCnG = 0;
    if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.gradepointsFirstCtrl.value){
      this.C_into_G = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) *  Number(this.edu_form.controls.gradepointsFirstCtrl.value))
      if(this.C_into_G>0){
        this.totalCnG = this.totalCnG + this.C_into_G;
        if(this.totalCnG && this.totalMarks){

          this.totalcgpa = Number(this.totalCnG) / Number(this.totalMarks)
          this.totalcgpa = Number(this.totalcgpa.toFixed(2))
        }
      }
    }

    if(this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.gradepointsSecondCtrl.value){
      this.C_into_G2 = (Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) *  Number(this.edu_form.controls.gradepointsSecondCtrl.value))

      if(this.C_into_G2>0){
        this.totalCnG = this.totalCnG + this.C_into_G2;
        if(this.totalCnG && this.totalMarks){

          this.totalcgpa = Number(this.totalCnG) / Number(this.totalMarks)
          this.totalcgpa = Number(this.totalcgpa.toFixed(2))
        }
      }

    }
    if(this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.gradepointsThirdCtrl.value){
      this.C_into_G3 = (Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) *  Number(this.edu_form.controls.gradepointsThirdCtrl.value))

      if(this.C_into_G3>0){
        this.totalCnG = this.totalCnG + this.C_into_G3;
        if(this.totalCnG && this.totalMarks){

          this.totalcgpa = Number(this.totalCnG) / Number(this.totalMarks)
          this.totalcgpa = Number(this.totalcgpa.toFixed(2))
        }
      }
    }

    if(this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.gradepointsFourthCtrl.value){
      this.C_into_G4 = (Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) *  Number(this.edu_form.controls.gradepointsFourthCtrl.value))
      

      if(this.C_into_G4>0){
        this.totalCnG = this.totalCnG + this.C_into_G4;
        if(this.totalCnG && this.totalMarks){

          this.totalcgpa = Number(this.totalCnG) / Number(this.totalMarks)
          this.totalcgpa = Number(this.totalcgpa.toFixed(2))
        }
      }
    }

    if(this.edu_form.controls.creditsEarnedCFifthCtrl.value && this.edu_form.controls.gradepointsFifthCtrl.value){
      this.C_into_G5 = (Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) *  Number(this.edu_form.controls.gradepointsFifthCtrl.value))
      
      if(this.C_into_G5>0){
        this.totalCnG = this.totalCnG + this.C_into_G5;
        if(this.totalCnG && this.totalMarks){

          this.totalcgpa = Number(this.totalCnG) / Number(this.totalMarks)
          this.totalcgpa = Number(this.totalcgpa.toFixed(2))
        }
      }
    }

    if(this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.gradepointsSixthCtrl.value){
      this.C_into_G6 = (Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) *  Number(this.edu_form.controls.gradepointsSixthCtrl.value))
      
      if(this.C_into_G6>0){
        this.totalCnG = this.totalCnG + this.C_into_G6;
        if(this.totalCnG && this.totalMarks){

          this.totalcgpa = Number(this.totalCnG) / Number(this.totalMarks)
          this.totalcgpa = Number(this.totalcgpa.toFixed(2))
        }
      }
    }

    if(this.edu_form.controls.creditsEarnedCSevenCtrl.value && this.edu_form.controls.gradepointsSeventhCtrl.value){
      this.C_into_G7 = (Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) *  Number(this.edu_form.controls.gradepointsSeventhCtrl.value))
      
      if(this.C_into_G7>0){
        this.totalCnG = this.totalCnG + this.C_into_G7;
        if(this.totalCnG && this.totalMarks){

          this.totalcgpa = Number(this.totalCnG) / Number(this.totalMarks)
          this.totalcgpa = Number(this.totalcgpa.toFixed(2))
        }
      }
    }

    if(this.edu_form.controls.creditsEarnedCEightCtrl.value && this.edu_form.controls.gradepointsEighthCtrl.value){
      this.C_into_G8 = (Number(this.edu_form.controls.creditsEarnedCEightCtrl.value) *  Number(this.edu_form.controls.gradepointsEighthCtrl.value))

      if(this.C_into_G8>0){
        this.totalCnG = this.totalCnG + this.C_into_G8;
        if(this.totalCnG && this.totalMarks){

          this.totalcgpa = Number(this.totalCnG) / Number(this.totalMarks)
          this.totalcgpa = Number(this.totalcgpa.toFixed(2))
        }
      }
    }

    if(this.edu_form.controls.creditsEarnedCNinthCtrl.value && this.edu_form.controls.gradepointsNinthCtrl.value){
      this.C_into_G9 = (Number(this.edu_form.controls.creditsEarnedCNinthCtrl.value) *  Number(this.edu_form.controls.gradepointsNinthCtrl.value))

      if(this.C_into_G9>0){
        this.totalCnG = this.totalCnG + this.C_into_G9;
        if(this.totalCnG && this.totalMarks){

          this.totalcgpa = Number(this.totalCnG) / Number(this.totalMarks)
          this.totalcgpa = Number(this.totalcgpa.toFixed(2))
        }
      }
    }

    if(this.edu_form.controls.creditsEarnedCtehthCtrl.value && this.edu_form.controls.gradepointsTenthCtrl.value){
      this.C_into_G10 = (Number(this.edu_form.controls.creditsEarnedCtehthCtrl.value) *  Number(this.edu_form.controls.gradepointsTenthCtrl.value))

      if(this.C_into_G10>0){
        this.totalCnG = this.totalCnG + this.C_into_G10;
        if(this.totalCnG && this.totalMarks){

          this.totalcgpa = Number(this.totalCnG) / Number(this.totalMarks)
          this.totalcgpa = Number(this.totalcgpa.toFixed(2))
        }
      }
    }




  }

  getTotalCourseCredits() {
    
    

    if (this.edu_form.controls.courseCreditsSecondCtrl.value != '' && this.edu_form.controls.courseCreditsThirdCtrl.value != '' && this.edu_form.controls.courseCreditsFourthCtrl.value != '' && this.edu_form.controls.courseCreditsFifthCtrl.value != '' && this.edu_form.controls.courseCreditsSixthCtrl.value != '' && this.edu_form.controls.courseCreditsSeventhCtrl.value != '' && this.edu_form.controls.courseCreditsEightCtrl.value != '' && this.edu_form.controls.courseCreditsNinthCtrl.value != '' && this.edu_form.controls.courseCreditsTenthCtrl.value != '' ) {
      this.totalMarks = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value) + Number(this.edu_form.controls.courseCreditsSeventhCtrl.value) + Number(this.edu_form.controls.courseCreditsEightCtrl.value) + Number(this.edu_form.controls.courseCreditsNinthCtrl.value) + Number(this.edu_form.controls.courseCreditsTenthCtrl.value))
    
    }
      else if (this.edu_form.controls.courseCreditsSecondCtrl.value != '' && this.edu_form.controls.courseCreditsThirdCtrl.value != '' && this.edu_form.controls.courseCreditsFourthCtrl.value != '' && this.edu_form.controls.courseCreditsFifthCtrl.value != '' && this.edu_form.controls.courseCreditsSixthCtrl.value != '' && this.edu_form.controls.courseCreditsSeventhCtrl.value != '' && this.edu_form.controls.courseCreditsEightCtrl.value != '' && this.edu_form.controls.courseCreditsNinthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value) + Number(this.edu_form.controls.courseCreditsSeventhCtrl.value) + Number(this.edu_form.controls.courseCreditsEightCtrl.value) + Number(this.edu_form.controls.courseCreditsNinthCtrl.value))
     
    }
      else if (this.edu_form.controls.courseCreditsSecondCtrl.value != '' && this.edu_form.controls.courseCreditsThirdCtrl.value != '' && this.edu_form.controls.courseCreditsFourthCtrl.value != '' && this.edu_form.controls.courseCreditsFifthCtrl.value != '' && this.edu_form.controls.courseCreditsSixthCtrl.value != '' && this.edu_form.controls.courseCreditsSeventhCtrl.value != '' && this.edu_form.controls.courseCreditsEightCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value) + Number(this.edu_form.controls.courseCreditsSeventhCtrl.value) + Number(this.edu_form.controls.courseCreditsEightCtrl.value))
      
    } else if (this.edu_form.controls.courseCreditsSecondCtrl.value != '' && this.edu_form.controls.courseCreditsThirdCtrl.value != '' && this.edu_form.controls.courseCreditsFourthCtrl.value != '' && this.edu_form.controls.courseCreditsFifthCtrl.value != '' && this.edu_form.controls.courseCreditsSixthCtrl.value != '' && this.edu_form.controls.courseCreditsSeventhCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value) + Number(this.edu_form.controls.courseCreditsSeventhCtrl.value))
      
    } else if (this.edu_form.controls.courseCreditsSecondCtrl.value != '' && this.edu_form.controls.courseCreditsThirdCtrl.value != '' && this.edu_form.controls.courseCreditsFourthCtrl.value != '' && this.edu_form.controls.courseCreditsFifthCtrl.value != '' && this.edu_form.controls.courseCreditsSixthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value))
      

    } else if (this.edu_form.controls.courseCreditsSecondCtrl.value != '' && this.edu_form.controls.courseCreditsThirdCtrl.value != '' && this.edu_form.controls.courseCreditsFourthCtrl.value != '' && this.edu_form.controls.courseCreditsFifthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value))

      
    } else if (this.edu_form.controls.courseCreditsSecondCtrl.value != '' && this.edu_form.controls.courseCreditsThirdCtrl.value != '' && this.edu_form.controls.courseCreditsFourthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value))

      
    } else if (this.edu_form.controls.courseCreditsSecondCtrl.value != '' && this.edu_form.controls.courseCreditsThirdCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value))
      
      
    } else if (this.edu_form.controls.courseCreditsSecondCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value))
      
    }

    this.totalCourseCredits = 0;
    if (this.edu_form.controls.courseCreditsFirstCtrl.value && this.edu_form.controls.courseCreditsSecondCtrl.value && this.edu_form.controls.courseCreditsThirdCtrl.value && this.edu_form.controls.courseCreditsFourthCtrl.value && this.edu_form.controls.courseCreditsFifthCtrl.value && this.edu_form.controls.courseCreditsSixthCtrl.value && this.edu_form.controls.courseCreditsSeventhCtrl.value && this.edu_form.controls.courseCreditsEighthCtrl.value && this.edu_form.controls.courseCreditsNinthOutCtrl.value && this.edu_form.controls.courseCreditsTenthOutCtrl.value) {
      this.totalCourseCredits = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value) + Number(this.edu_form.controls.courseCreditsSeventhCtrl.value) + Number(this.edu_form.controls.courseCreditsEighthCtrl.value) + Number(this.edu_form.controls.courseCreditsNinthOutCtrl.value) + Number(this.edu_form.controls.courseCreditsTenthOutCtrl.value))
    } else if (this.edu_form.controls.courseCreditsFirstCtrl.value && this.edu_form.controls.courseCreditsSecondCtrl.value && this.edu_form.controls.courseCreditsThirdCtrl.value && this.edu_form.controls.courseCreditsFourthCtrl.value && this.edu_form.controls.courseCreditsFifthCtrl.value && this.edu_form.controls.courseCreditsSixthCtrl.value && this.edu_form.controls.courseCreditsSeventhCtrl.value && this.edu_form.controls.courseCreditsEighthCtrl.value && this.edu_form.controls.courseCreditsNinthOutCtrl.value) {
      this.totalCourseCredits = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value) + Number(this.edu_form.controls.courseCreditsSeventhCtrl.value) + Number(this.edu_form.controls.courseCreditsEighthCtrl.value) + Number(this.edu_form.controls.courseCreditsNinthOutCtrl.value))
    } else if (this.edu_form.controls.courseCreditsFirstCtrl.value && this.edu_form.controls.courseCreditsSecondCtrl.value && this.edu_form.controls.courseCreditsThirdCtrl.value && this.edu_form.controls.courseCreditsFourthCtrl.value && this.edu_form.controls.courseCreditsFifthCtrl.value && this.edu_form.controls.courseCreditsSixthCtrl.value && this.edu_form.controls.courseCreditsSeventhCtrl.value && this.edu_form.controls.courseCreditsEighthCtrl.value) {
      this.totalCourseCredits = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value) + Number(this.edu_form.controls.courseCreditsSeventhCtrl.value) + Number(this.edu_form.controls.courseCreditsEighthCtrl.value))
    } else if (this.edu_form.controls.courseCreditsFirstCtrl.value && this.edu_form.controls.courseCreditsSecondCtrl.value && this.edu_form.controls.courseCreditsThirdCtrl.value && this.edu_form.controls.courseCreditsFourthCtrl.value && this.edu_form.controls.courseCreditsFifthCtrl.value && this.edu_form.controls.courseCreditsSixthCtrl.value && this.edu_form.controls.courseCreditsSeventhCtrl.value) {
      this.totalCourseCredits = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value) + Number(this.edu_form.controls.courseCreditsSeventhCtrl.value))
    } else if (this.edu_form.controls.courseCreditsFirstCtrl.value && this.edu_form.controls.courseCreditsSecondCtrl.value && this.edu_form.controls.courseCreditsThirdCtrl.value && this.edu_form.controls.courseCreditsFourthCtrl.value && this.edu_form.controls.courseCreditsFifthCtrl.value && this.edu_form.controls.courseCreditsSixthCtrl.value) {
      this.totalCourseCredits = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value))
    } else if (this.edu_form.controls.courseCreditsFirstCtrl.value && this.edu_form.controls.courseCreditsSecondCtrl.value && this.edu_form.controls.courseCreditsThirdCtrl.value && this.edu_form.controls.courseCreditsFourthCtrl.value && this.edu_form.controls.courseCreditsFifthCtrl.value) {
      this.totalCourseCredits = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value))
    } else if (this.edu_form.controls.courseCreditsFirstCtrl.value && this.edu_form.controls.courseCreditsSecondCtrl.value && this.edu_form.controls.courseCreditsThirdCtrl.value && this.edu_form.controls.courseCreditsFourthCtrl.value) {
      this.totalCourseCredits = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value))
    } else if (this.edu_form.controls.courseCreditsFirstCtrl.value && this.edu_form.controls.courseCreditsSecondCtrl.value && this.edu_form.controls.courseCreditsThirdCtrl.value) {
      this.totalCourseCredits = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value))
    } else if (this.edu_form.controls.courseCreditsFirstCtrl.value && this.edu_form.controls.courseCreditsSecondCtrl.value) {
      this.totalCourseCredits = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value))
    }
  }

   // total marks for sf
   totalM() {
    
    
    this.th_ia_1= 0;
    if(this.edu_form.controls.thFirstCtrl.value && this.edu_form.controls.iaFirstCtrl.value){
      
    
    
      this.th_ia_1 = (Number(this.edu_form.controls.thFirstCtrl.value) +  Number(this.edu_form.controls.iaFirstCtrl.value))
      
      
    }

    if(this.edu_form.controls.thSecondCtrl.value && this.edu_form.controls.iaSecondCtrl.value){
      
      this.th_ia_2 = (Number(this.edu_form.controls.thSecondCtrl.value) +  Number(this.edu_form.controls.iaSecondCtrl.value))
      
    }

    if(this.edu_form.controls.thThirdCtrl.value && this.edu_form.controls.iaThirdCtrl.value){
      this.th_ia_3 = (Number(this.edu_form.controls.thThirdCtrl.value) +  Number(this.edu_form.controls.iaThirdCtrl.value))
    }

   
    if(this.edu_form.controls.thFourthCtrl.value && this.edu_form.controls.iaFourthCtrl.value){
      this.th_ia_4 = (Number(this.edu_form.controls.thFourthCtrl.value) + Number(this.edu_form.controls.iaFourthCtrl.value))
    }

    if(this.edu_form.controls.thFifthCtrl.value && this.edu_form.controls.iaFifthCtrl.value){
      this.th_ia_5 = (Number(this.edu_form.controls.thFifthCtrl.value) +  Number(this.edu_form.controls.iaFifthCtrl.value))
    }

    if(this.edu_form.controls.thSixthCtrl.value && this.edu_form.controls.iaSixthCtrl.value){
      this.th_ia_6 = (Number(this.edu_form.controls.thSixthCtrl.value) +  Number(this.edu_form.controls.iaSixthCtrl.value))
    }

    if(this.edu_form.controls.thSeventhCtrl.value && this.edu_form.controls.iaSeventhCtrl.value){
      this.th_ia_7 = (Number(this.edu_form.controls.thSeventhCtrl.value) +  Number(this.edu_form.controls.iaSeventhCtrl.value))
    }

    if(this.edu_form.controls.thEightCtrl.value && this.edu_form.controls.iaEightCtrl.value){
      this.th_ia_8 = (Number(this.edu_form.controls.thEightCtrl.value) +  Number(this.edu_form.controls.iaEightCtrl.value))
    }

    if(this.edu_form.controls.thNinthCtrl.value && this.edu_form.controls.iaNinthCtrl.value){
      this.th_ia_9 = (Number(this.edu_form.controls.thNinthCtrl.value) +  Number(this.edu_form.controls.iaNinthCtrl.value))
    }

    if(this.edu_form.controls.thTenthCtrl.value && this.edu_form.controls.iaTenthCtrl.value){
      this.th_ia_10 = (Number(this.edu_form.controls.thTenthCtrl.value) +  Number(this.edu_form.controls.iaTenthCtrl.value))
    }




  }

  totalsMarksObtained() {
    this.totalMarksObtained = 0
    if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '' && this.edu_form.controls.markObtFifthCtrl.value != '' && this.edu_form.controls.markObtSixthCtrl.value != '' && this.edu_form.controls.markObtSeventhCtrl.value != '' && this.edu_form.controls.markObtEightCtrl.value != '' && this.edu_form.controls.markObtNinthCtrl.value != '' && this.edu_form.controls.markObtTenthCtrl.value != '') {
      this.totalMarksObtained = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value) + Number(this.edu_form.controls.markObtFifthCtrl.value) + Number(this.edu_form.controls.markObtSixthCtrl.value) + Number(this.edu_form.controls.markObtSeventhCtrl.value) + Number(this.edu_form.controls.markObtEightCtrl.value) + Number(this.edu_form.controls.markObtNinthCtrl.value) + Number(this.edu_form.controls.markObtTenthCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '' && this.edu_form.controls.markObtFifthCtrl.value != '' && this.edu_form.controls.markObtSixthCtrl.value != '' && this.edu_form.controls.markObtSeventhCtrl.value != '' && this.edu_form.controls.markObtEightCtrl.value != '' && this.edu_form.controls.markObtNinthCtrl.value != '') {
      this.totalMarksObtained = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value) + Number(this.edu_form.controls.markObtFifthCtrl.value) + Number(this.edu_form.controls.markObtSixthCtrl.value) + Number(this.edu_form.controls.markObtSeventhCtrl.value) + Number(this.edu_form.controls.markObtEightCtrl.value) + Number(this.edu_form.controls.markObtNinthCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '' && this.edu_form.controls.markObtFifthCtrl.value != '' && this.edu_form.controls.markObtSixthCtrl.value != '' && this.edu_form.controls.markObtSeventhCtrl.value != '' && this.edu_form.controls.markObtEightCtrl.value) {
      this.totalMarksObtained = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value) + Number(this.edu_form.controls.markObtFifthCtrl.value) + Number(this.edu_form.controls.markObtSixthCtrl.value) + Number(this.edu_form.controls.markObtSeventhCtrl.value) + Number(this.edu_form.controls.markObtEightCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '' && this.edu_form.controls.markObtFifthCtrl.value != '' && this.edu_form.controls.markObtSixthCtrl.value != '' && this.edu_form.controls.markObtSeventhCtrl.value != '') {
      this.totalMarksObtained = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value) + Number(this.edu_form.controls.markObtFifthCtrl.value) + Number(this.edu_form.controls.markObtSixthCtrl.value) + Number(this.edu_form.controls.markObtSeventhCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '' && this.edu_form.controls.markObtFifthCtrl.value != '' && this.edu_form.controls.markObtSixthCtrl.value != '') {
      this.totalMarksObtained = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value) + Number(this.edu_form.controls.markObtFifthCtrl.value) + Number(this.edu_form.controls.markObtSixthCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '' && this.edu_form.controls.markObtFifthCtrl.value != '') {
      this.totalMarksObtained = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value) + Number(this.edu_form.controls.markObtFifthCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '') {
      this.totalMarksObtained = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '') {
      this.totalMarksObtained = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '') {
      this.totalMarksObtained = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value))
    }
  }

   // addition for ba sgpi
   AdditionMarks(){
    if(this.edu_form.controls.minInternalMarksFirstCtrl.value && this.edu_form.controls.minMarksFirstCtrl.value){
      
    
    
      this.internal_marks = (Number(this.edu_form.controls.minInternalMarksFirstCtrl.value) +  Number(this.edu_form.controls.minMarksFirstCtrl.value))
      
      
    }

  }

  totalsMarksObtainedMyFunc() {
    this.totalMarksObtainedmyFunc = 0
    if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '' && this.edu_form.controls.markObtFifthCtrl.value != '' && this.edu_form.controls.markObtSixthCtrl.value != '' && this.edu_form.controls.markObtSeventhCtrl.value != '' && this.edu_form.controls.markObtEightCtrl.value != '' && this.edu_form.controls.markObtNinthCtrl.value != '' && this.edu_form.controls.markObtTenthCtrl.value != '') {
      this.totalMarksObtainedmyFunc = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value) + Number(this.edu_form.controls.markObtFifthCtrl.value) + Number(this.edu_form.controls.markObtSixthCtrl.value) + Number(this.edu_form.controls.markObtSeventhCtrl.value) + Number(this.edu_form.controls.markObtEightCtrl.value) + Number(this.edu_form.controls.markObtNinthCtrl.value) + Number(this.edu_form.controls.markObtTenthCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '' && this.edu_form.controls.markObtFifthCtrl.value != '' && this.edu_form.controls.markObtSixthCtrl.value != '' && this.edu_form.controls.markObtSeventhCtrl.value != '' && this.edu_form.controls.markObtEightCtrl.value != '' && this.edu_form.controls.markObtNinthCtrl.value != '') {
      this.totalMarksObtainedmyFunc = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value) + Number(this.edu_form.controls.markObtFifthCtrl.value) + Number(this.edu_form.controls.markObtSixthCtrl.value) + Number(this.edu_form.controls.markObtSeventhCtrl.value) + Number(this.edu_form.controls.markObtEightCtrl.value) + Number(this.edu_form.controls.markObtNinthCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '' && this.edu_form.controls.markObtFifthCtrl.value != '' && this.edu_form.controls.markObtSixthCtrl.value != '' && this.edu_form.controls.markObtSeventhCtrl.value != '' && this.edu_form.controls.markObtEightCtrl.value) {
      this.totalMarksObtainedmyFunc = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value) + Number(this.edu_form.controls.markObtFifthCtrl.value) + Number(this.edu_form.controls.markObtSixthCtrl.value) + Number(this.edu_form.controls.markObtSeventhCtrl.value) + Number(this.edu_form.controls.markObtEightCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '' && this.edu_form.controls.markObtFifthCtrl.value != '' && this.edu_form.controls.markObtSixthCtrl.value != '' && this.edu_form.controls.markObtSeventhCtrl.value != '') {
      this.totalMarksObtainedmyFunc = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value) + Number(this.edu_form.controls.markObtFifthCtrl.value) + Number(this.edu_form.controls.markObtSixthCtrl.value) + Number(this.edu_form.controls.markObtSeventhCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '' && this.edu_form.controls.markObtFifthCtrl.value != '' && this.edu_form.controls.markObtSixthCtrl.value != '') {
      this.totalMarksObtainedmyFunc = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value) + Number(this.edu_form.controls.markObtFifthCtrl.value) + Number(this.edu_form.controls.markObtSixthCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '' && this.edu_form.controls.markObtFifthCtrl.value != '') {
      this.totalMarksObtainedmyFunc = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value) + Number(this.edu_form.controls.markObtFifthCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '') {
      this.totalMarksObtainedmyFunc = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '') {
      this.totalMarksObtainedmyFunc = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '') {
      this.totalMarksObtainedmyFunc = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value))
    }
  }

  totalsMaximumMarks() {
    this.totalMaximumMarks = 0
    if (this.edu_form.controls.maxMarksSecondCtrl.value != '' && this.edu_form.controls.maxMarksThirdCtrl.value != '' && this.edu_form.controls.maxMarksFourthCtrl.value != '' && this.edu_form.controls.maxMarksFifthCtrl.value != '' && this.edu_form.controls.maxMarksSixthCtrl.value != '' && this.edu_form.controls.maxMarksSeventhCtrl.value != '' && this.edu_form.controls.maxMarksEightCtrl.value != '' && this.edu_form.controls.maxMarksNinthCtrl.value != '' && this.edu_form.controls.maxMarksTenthCtrl.value != '') {
      this.totalMaximumMarks = (Number(this.edu_form.controls.maxMarksFirstCtrl.value) + Number(this.edu_form.controls.maxMarksSecondCtrl.value) + Number(this.edu_form.controls.maxMarksThirdCtrl.value) + Number(this.edu_form.controls.maxMarksFourthCtrl.value) + Number(this.edu_form.controls.maxMarksFifthCtrl.value) + Number(this.edu_form.controls.maxMarksSixthCtrl.value) + Number(this.edu_form.controls.maxMarksSeventhCtrl.value) + Number(this.edu_form.controls.maxMarksEightCtrl.value) + Number(this.edu_form.controls.maxMarksNinthCtrl.value) + Number(this.edu_form.controls.maxMarksTenthCtrl.value))
    } else if (this.edu_form.controls.maxMarksSecondCtrl.value != '' && this.edu_form.controls.maxMarksThirdCtrl.value != '' && this.edu_form.controls.maxMarksFourthCtrl.value != '' && this.edu_form.controls.maxMarksFifthCtrl.value != '' && this.edu_form.controls.maxMarksSixthCtrl.value != '' && this.edu_form.controls.maxMarksSeventhCtrl.value != '' && this.edu_form.controls.maxMarksEightCtrl.value != '' && this.edu_form.controls.maxMarksNinthCtrl.value != '') {
      this.totalMaximumMarks = (Number(this.edu_form.controls.maxMarksFirstCtrl.value) + Number(this.edu_form.controls.maxMarksSecondCtrl.value) + Number(this.edu_form.controls.maxMarksThirdCtrl.value) + Number(this.edu_form.controls.maxMarksFourthCtrl.value) + Number(this.edu_form.controls.maxMarksFifthCtrl.value) + Number(this.edu_form.controls.maxMarksSixthCtrl.value) + Number(this.edu_form.controls.maxMarksSeventhCtrl.value) + Number(this.edu_form.controls.maxMarksEightCtrl.value) + Number(this.edu_form.controls.maxMarksNinthCtrl.value))
    } else if (this.edu_form.controls.maxMarksSecondCtrl.value != '' && this.edu_form.controls.maxMarksThirdCtrl.value != '' && this.edu_form.controls.maxMarksFourthCtrl.value != '' && this.edu_form.controls.maxMarksFifthCtrl.value != '' && this.edu_form.controls.maxMarksSixthCtrl.value != '' && this.edu_form.controls.maxMarksSeventhCtrl.value != '' && this.edu_form.controls.maxMarksEightCtrl.value) {
      this.totalMaximumMarks = (Number(this.edu_form.controls.maxMarksFirstCtrl.value) + Number(this.edu_form.controls.maxMarksSecondCtrl.value) + Number(this.edu_form.controls.maxMarksThirdCtrl.value) + Number(this.edu_form.controls.maxMarksFourthCtrl.value) + Number(this.edu_form.controls.maxMarksFifthCtrl.value) + Number(this.edu_form.controls.maxMarksSixthCtrl.value) + Number(this.edu_form.controls.maxMarksSeventhCtrl.value) + Number(this.edu_form.controls.maxMarksEightCtrl.value))
    } else if (this.edu_form.controls.maxMarksSecondCtrl.value != '' && this.edu_form.controls.maxMarksThirdCtrl.value != '' && this.edu_form.controls.maxMarksFourthCtrl.value != '' && this.edu_form.controls.maxMarksFifthCtrl.value != '' && this.edu_form.controls.maxMarksSixthCtrl.value != '' && this.edu_form.controls.maxMarksSeventhCtrl.value != '') {
      this.totalMaximumMarks = (Number(this.edu_form.controls.maxMarksFirstCtrl.value) + Number(this.edu_form.controls.maxMarksSecondCtrl.value) + Number(this.edu_form.controls.maxMarksThirdCtrl.value) + Number(this.edu_form.controls.maxMarksFourthCtrl.value) + Number(this.edu_form.controls.maxMarksFifthCtrl.value) + Number(this.edu_form.controls.maxMarksSixthCtrl.value) + Number(this.edu_form.controls.maxMarksSeventhCtrl.value))
    } else if (this.edu_form.controls.maxMarksSecondCtrl.value != '' && this.edu_form.controls.maxMarksThirdCtrl.value != '' && this.edu_form.controls.maxMarksFourthCtrl.value != '' && this.edu_form.controls.maxMarksFifthCtrl.value != '' && this.edu_form.controls.maxMarksSixthCtrl.value != '') {
      this.totalMaximumMarks = (Number(this.edu_form.controls.maxMarksFirstCtrl.value) + Number(this.edu_form.controls.maxMarksSecondCtrl.value) + Number(this.edu_form.controls.maxMarksThirdCtrl.value) + Number(this.edu_form.controls.maxMarksFourthCtrl.value) + Number(this.edu_form.controls.maxMarksFifthCtrl.value) + Number(this.edu_form.controls.maxMarksSixthCtrl.value))
    } else if (this.edu_form.controls.maxMarksSecondCtrl.value != '' && this.edu_form.controls.maxMarksThirdCtrl.value != '' && this.edu_form.controls.maxMarksFourthCtrl.value != '' && this.edu_form.controls.maxMarksFifthCtrl.value != '') {
      this.totalMaximumMarks = (Number(this.edu_form.controls.maxMarksFirstCtrl.value) + Number(this.edu_form.controls.maxMarksSecondCtrl.value) + Number(this.edu_form.controls.maxMarksThirdCtrl.value) + Number(this.edu_form.controls.maxMarksFourthCtrl.value) + Number(this.edu_form.controls.maxMarksFifthCtrl.value))
    } else if (this.edu_form.controls.maxMarksSecondCtrl.value != '' && this.edu_form.controls.maxMarksThirdCtrl.value != '' && this.edu_form.controls.maxMarksFourthCtrl.value != '') {
      this.totalMaximumMarks = (Number(this.edu_form.controls.maxMarksFirstCtrl.value) + Number(this.edu_form.controls.maxMarksSecondCtrl.value) + Number(this.edu_form.controls.maxMarksThirdCtrl.value) + Number(this.edu_form.controls.maxMarksFourthCtrl.value))
    } else if (this.edu_form.controls.maxMarksSecondCtrl.value != '' && this.edu_form.controls.maxMarksThirdCtrl.value != '') {
      this.totalMaximumMarks = (Number(this.edu_form.controls.maxMarksFirstCtrl.value) + Number(this.edu_form.controls.maxMarksSecondCtrl.value) + Number(this.edu_form.controls.maxMarksThirdCtrl.value))
    } else if (this.edu_form.controls.maxMarksSecondCtrl.value != '') {
      this.totalMaximumMarks = (Number(this.edu_form.controls.maxMarksFirstCtrl.value) + Number(this.edu_form.controls.maxMarksSecondCtrl.value))
    }
  }

  onChange(event,no) {
    if(no=='1'){
      if(event.checked == true){
        this.instruction1 = true;
        this.special_instruction1 = '@ As per University of Mumbai Ordinance 0.5042A/0.5043A/0.5044A'
      }
      if(event.checked == false){
        this.instruction1 = false;
        this.special_instruction1 = null
      }
    }else if(no=='2'){
      if(event.checked == true){
        this.instruction2 = true;
        this.special_instruction2 = '& Scaled Down, Cir. No. UG/61 of 2013-2014'
      }
      if(event.checked == false){
        this.instruction2 = false;
        this.special_instruction2 = null
      }
    }else if(no=='3'){
      if(event.checked == true){
        this.instruction3 = true;
        this.special_instruction3 = '+ Carried Forward Marks as per Ordinance of University of Mumbai'
      }
      if(event.checked == false){
        this.instruction3 = false;
        this.special_instruction3 = null
      }
    }else if(no=='4'){
      if(event.checked == true){
        this.instruction4 = true;
        this.special_instruction4 = '* As per University of Mumbai Ordinance 0.5045a'
      }
       if(event.checked == false){
        this.instruction4 = false;
        this.special_instruction4 = null
      }
    }else if(no=='5'){
      if(event.checked == true){
        this.instruction5 = true;
        this.special_instruction5 = '$ - Carried forward grade as per ordinance of the University of Mumbai'
      }
      if(event.checked == false){
        this.instruction5 = false;
        this.special_instruction5 = null
      }
    }else if(no=='6'){
      if(event.checked == true){
        this.instruction6 = true;
        this.special_instruction6 = '# As per University of Mumbai, Ordinance 0.229'
      }
      if(event.checked == false){
        this.instruction6 = false;
        this.special_instruction6 = null
      }
    }else if(no=='7'){
      if(event.checked == true){
        this.instruction7 = true;
        this.special_instruction7 = '& As per University of Mumbai Ordinance. O.224'
      }
      if(event.checked == false){
        this.instruction7 = false;
        this.special_instruction7 = null
      }
    }
  }
  

  updateSpecialInstruction(val) {
    this.specialInstruction = val
  }

  getSpecialInst(event: any) {

    this.specialInstruction = event.target.value

  }

  updateGradeSpecialInstruction(val) {
    
    this.GradespecialInstruction = val
  }

  getGradeSpecialInst(event: any) {

    this.GradespecialInstruction = event.target.value

  }

  showcoursecodeDropdown() {
    this.showcodeDropdown = true;
  }
  
  showcoursecodeDropdown2() {
    this.showcodeDropdown2 = true;
  }
  
  showcoursecodeDropdown3() {
    this.showcodeDropdown3 = true;
  }
  
  showcoursecodeDropdown4() {
    this.showcodeDropdown4 = true;
  }
  
  showcoursecodeDropdown5() {
    this.showcodeDropdown5 = true;
  }
  
  showcoursecodeDropdown6() {
    this.showcodeDropdown6 = true;
  }
  
  showcoursecodeDropdown7() {
    this.showcodeDropdown7 = true;
  }
  
  showcoursecodeDropdown8() {
    this.showcodeDropdown8 = true;
  }
  
  showcoursecodeDropdown9() {
    this.showcodeDropdown9 = true;
  }
  
  showcoursecodeDropdown10() {
    this.showcodeDropdown10 = true;
  }


}